function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("symbol", {
  id: "musd",
  viewBox: "0 0 53.831 55.4"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 27.5,
  r: 27
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.639 37.518c-6.402-.564-11.062-3.907-11.298-9.979h8.567c.188 1.93 1.13 3.106 2.73 3.625v-7.438c-5.037-1.318-11.345-2.73-11.345-10.121 0-5.884 4.943-9.368 11.345-9.792V0h3.013v3.813c6.449.518 10.592 3.813 11.015 9.792h-8.614c-.188-1.742-1.082-2.825-2.4-3.295v7.296c5.037 1.412 11.485 2.777 11.485 10.074 0 5.083-4.048 9.556-11.485 9.885v3.813h-3.013v-3.86zm0-20.901v-6.543c-1.742.283-2.825 1.318-2.825 3.154 0 1.647 1.13 2.636 2.825 3.389zm3.012 8.003v6.684c1.883-.329 3.06-1.6 3.06-3.342 0-1.695-1.224-2.636-3.06-3.342z",
  transform: "matrix(.6 0 0 .6 11 9.5)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 47.288h53.831V55.4H0z",
  transform: "matrix(.6 0 0 .6 11 9.5)"
}))), /*#__PURE__*/React.createElement("style", null, "*{stroke-linecap:butt;stroke-linejoin:round}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  strokeLinejoin: "round",
  transform: "translate(20 20)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M584 492l-32 7-4-14 34-7z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552 499l-27 10-6-16 29-8z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M582 478l-34 7-3-18 35-5z",
  clipPath: "url(#peee9962114)",
  fill: "#0028ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M548 485l-29 8-6-18 32-8z",
  clipPath: "url(#peee9962114)",
  fill: "#0018ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M586 504l-30 7-4-12 32-7z",
  clipPath: "url(#peee9962114)",
  fill: "#0000f1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M556 511l-25 10-6-12 27-10z",
  clipPath: "url(#peee9962114)",
  fill: "#0000da",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M580 462l-35 5-4-19 37-4z",
  clipPath: "url(#peee9962114)",
  fill: "#0058ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M545 467l-32 8-4-20 32-7z",
  clipPath: "url(#peee9962114)",
  fill: "#0048ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M618 488l-34 4-2-14 36-3z",
  clipPath: "url(#peee9962114)",
  fill: "#0014ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M588 512l-27 8-5-9 30-7z",
  clipPath: "url(#peee9962114)",
  fill: "#0000da",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M525 509l-23 11-8-16 25-11z",
  clipPath: "url(#peee9962114)",
  fill: "#0000e8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M561 520l-23 10-7-9 25-10z",
  clipPath: "url(#peee9962114)",
  fill: "#0000c4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M618 475l-36 3-2-16 38-3z",
  clipPath: "url(#peee9962114)",
  fill: "#003cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M519 493l-25 11-7-18 26-11z",
  clipPath: "url(#peee9962114)",
  fill: "#0008ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M618 498l-32 6-2-12 34-4z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M531 521l-21 12-8-13 23-11z",
  clipPath: "url(#peee9962114)",
  fill: "#0000c8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578 444l-37 4-2-21 38-3z",
  clipPath: "url(#peee9962114)",
  fill: "#0090ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M541 448l-32 7-4-22 34-6z",
  clipPath: "url(#peee9962114)",
  fill: "#0084ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M618 459l-38 3-2-18 40-2z",
  clipPath: "url(#peee9962114)",
  fill: "#0068ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M513 475l-26 11-6-21 28-10z",
  clipPath: "url(#peee9962114)",
  fill: "#003cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M619 506l-31 6-2-8 32-6z",
  clipPath: "url(#peee9962114)",
  fill: "#0000f6",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M590 517l-25 9-4-6 27-8z",
  clipPath: "url(#peee9962114)",
  fill: "#0000d1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M538 530l-19 13-9-10 21-12z",
  clipPath: "url(#peee9962114)",
  fill: "#0000ad",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565 526l-21 10-6-6 23-10z",
  clipPath: "url(#peee9962114)",
  fill: "#00b",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M618 442l-40 2-1-20h41z",
  clipPath: "url(#peee9962114)",
  fill: "#009cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M509 455l-28 10-5-23 29-9z",
  clipPath: "url(#peee9962114)",
  fill: "#0078ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M619 511l-29 6-2-5 31-6z",
  clipPath: "url(#peee9962114)",
  fill: "#0000ed",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M577 424l-38 3-2-22 39-2z",
  clipPath: "url(#peee9962114)",
  fill: "#0cf",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M654 485l-36 3v-13l38-2z",
  clipPath: "url(#peee9962114)",
  fill: "#002cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539 427l-34 6-3-23 35-5z",
  clipPath: "url(#peee9962114)",
  fill: "#00c4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M653 495l-35 3v-10l36-3z",
  clipPath: "url(#peee9962114)",
  fill: "#0014ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656 473l-38 2v-16h39z",
  clipPath: "url(#peee9962114)",
  fill: "#0050ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M502 520l-17 14-10-16 19-14z",
  clipPath: "url(#peee9962114)",
  fill: "#0000da",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M494 504l-19 14-9-19 21-13z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M544 536l-16 12-9-5 19-13z",
  clipPath: "url(#peee9962114)",
  fill: "#0000a4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M510 533l-15 14-10-13 17-14z",
  clipPath: "url(#peee9962114)",
  fill: "#0000b6",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M593 519l-23 9-5-2 25-9z",
  clipPath: "url(#peee9962114)",
  fill: "#0000d6",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M651 502l-32 4-1-8 35-3z",
  clipPath: "url(#peee9962114)",
  fill: "#0004ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M657 459h-39v-17l40 1z",
  clipPath: "url(#peee9962114)",
  fill: "#0078ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M570 528l-19 10-7-2 21-10z",
  clipPath: "url(#peee9962114)",
  fill: "#0000bf",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M618 424h-41l-1-21 42 1z",
  clipPath: "url(#peee9962114)",
  fill: "#00d8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M487 486l-21 13-7-22 22-12z",
  clipPath: "url(#peee9962114)",
  fill: "#0034ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M619 512l-26 7-3-2 29-6z",
  clipPath: "url(#peee9962114)",
  fill: "#0000f1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M519 543l-13 13-11-9 15-14z",
  clipPath: "url(#peee9962114)",
  fill: "#00009f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M505 433l-29 9-4-24 30-8z",
  clipPath: "url(#peee9962114)",
  fill: "#00bcff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M649 506l-30 5v-5l32-4z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M576 403l-39 2-1-23h40z",
  clipPath: "url(#peee9962114)",
  fill: "#23ffd4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M658 443l-40-1v-18l41 2z",
  clipPath: "url(#peee9962114)",
  fill: "#00acff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M537 405l-35 5-2-23 36-5z",
  clipPath: "url(#peee9962114)",
  fill: "#1cffdb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M551 538l-14 12-9-2 16-12z",
  clipPath: "url(#peee9962114)",
  fill: "#0000ad",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M481 465l-22 12-7-23 24-12z",
  clipPath: "url(#peee9962114)",
  fill: "#0070ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M595 517l-21 9-4 2 23-9z",
  clipPath: "url(#peee9962114)",
  fill: "#0000e8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M528 548l-11 14-11-6 13-13z",
  clipPath: "url(#peee9962114)",
  fill: "#000096",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M618 404l-42-1v-21l42 2z",
  clipPath: "url(#peee9962114)",
  fill: "#26ffd1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M648 507l-29 5v-2l30-4z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M690 485h-36l2-12 37 1z",
  clipPath: "url(#peee9962114)",
  fill: "#04f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M687 494l-34 1 1-10h36z",
  clipPath: "url(#peee9962114)",
  fill: "#002cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M574 526l-16 11-7 1 19-10z",
  clipPath: "url(#peee9962114)",
  fill: "#0000d1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M659 426l-41-2v-20l42 4z",
  clipPath: "url(#peee9962114)",
  fill: "#00e0fb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M619 510l-24 7-2 2 26-7z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M693 474l-37-1 1-14 38 2z",
  clipPath: "url(#peee9962114)",
  fill: "#0064ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M502 410l-30 9-3-25 31-7z",
  clipPath: "url(#peee9962114)",
  fill: "#19ffde",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M684 500l-33 2 2-7 34-1z",
  clipPath: "url(#peee9962114)",
  fill: "#001cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M485 534l-12 15-12-16 14-15z",
  clipPath: "url(#peee9962114)",
  fill: "#0000d1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M495 547l-10 15-12-13 12-15z",
  clipPath: "url(#peee9962114)",
  fill: "#0000a8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M576 382h-40l-1-22h41z",
  clipPath: "url(#peee9962114)",
  fill: "#5aff9d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M695 461l-38-2 1-16 40 4z",
  clipPath: "url(#peee9962114)",
  fill: "#008cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475 518l-14 15-10-19 15-15z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M476 442l-24 12-5-24 25-11z",
  clipPath: "url(#peee9962114)",
  fill: "#00b8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M536 382l-36 5-1-24 36-3z",
  clipPath: "url(#peee9962114)",
  fill: "#5aff9d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M680 503l-31 3 2-4 33-2z",
  clipPath: "url(#peee9962114)",
  fill: "#0018ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M558 537l-12 12-9 1 14-12z",
  clipPath: "url(#peee9962114)",
  fill: "#0000bf",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M537 550l-9 14-11-2 11-14z",
  clipPath: "url(#peee9962114)",
  fill: "#00009b",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M506 556l-8 15-13-9 10-15z",
  clipPath: "url(#peee9962114)",
  fill: "#000092",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M646 505l-27 5v2l29-5z",
  clipPath: "url(#peee9962114)",
  fill: "#000cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M466 499l-15 15-9-22 17-15z",
  clipPath: "url(#peee9962114)",
  fill: "#002cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M618 384l-42-2v-22l42 4z",
  clipPath: "url(#peee9962114)",
  fill: "#5dff9a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M660 408l-42-4v-20l43 5z",
  clipPath: "url(#peee9962114)",
  fill: "#2cffca",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M698 447l-40-4 1-17 41 5z",
  clipPath: "url(#peee9962114)",
  fill: "#00b8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M597 512l-19 9-4 5 21-9z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M619 505l-22 7-2 5 24-7z",
  clipPath: "url(#peee9962114)",
  fill: "#000cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M677 504l-29 3 1-1 31-3z",
  clipPath: "url(#peee9962114)",
  fill: "#0018ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578 521l-14 10-6 6 16-11z",
  clipPath: "url(#peee9962114)",
  fill: "#0000f1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M500 387l-31 7-1-24 31-7z",
  clipPath: "url(#peee9962114)",
  fill: "#56ffa0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M517 562l-6 14-13-5 8-15z",
  clipPath: "url(#peee9962114)",
  fill: "#000089",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M459 477l-17 15-7-23 17-15z",
  clipPath: "url(#peee9962114)",
  fill: "#006cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M472 419l-25 11-3-25 25-11z",
  clipPath: "url(#peee9962114)",
  fill: "#16ffe1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M700 431l-41-5 1-18 41 6z",
  clipPath: "url(#peee9962114)",
  fill: "#06ecf1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M576 360h-41l1-22 40 1z",
  clipPath: "url(#peee9962114)",
  fill: "#94ff63",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M645 500l-26 5v5l27-5z",
  clipPath: "url(#peee9962114)",
  fill: "#0024ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M546 549l-7 13-11 2 9-14z",
  clipPath: "url(#peee9962114)",
  fill: "#0000ad",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M719 494h-32l3-9 33 2z",
  clipPath: "url(#peee9962114)",
  fill: "#04f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M723 487l-33-2 3-11 34 3z",
  clipPath: "url(#peee9962114)",
  fill: "#005cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M661 389l-43-5v-20l43 6z",
  clipPath: "url(#peee9962114)",
  fill: "#5dff9a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M535 360l-36 3v-23l37-2z",
  clipPath: "url(#peee9962114)",
  fill: "#94ff63",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M674 502l-28 3 2 2 29-3z",
  clipPath: "url(#peee9962114)",
  fill: "#0028ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564 531l-10 12-8 6 12-12z",
  clipPath: "url(#peee9962114)",
  fill: "#0000df",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M714 500h-30l3-6h32z",
  clipPath: "url(#peee9962114)",
  fill: "#0038ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727 477l-34-3 2-13 36 4z",
  clipPath: "url(#peee9962114)",
  fill: "#0078ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M618 364l-42-4v-21l42 5z",
  clipPath: "url(#peee9962114)",
  fill: "#90ff66",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M528 564l-4 14-13-2 6-14z",
  clipPath: "url(#peee9962114)",
  fill: "#00008d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M599 504l-17 8-4 9 19-9z",
  clipPath: "url(#peee9962114)",
  fill: "#001cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M710 502l-30 1 4-3h30z",
  clipPath: "url(#peee9962114)",
  fill: "#0034ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M620 497l-21 7-2 8 22-7z",
  clipPath: "url(#peee9962114)",
  fill: "#0030ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M731 465l-36-4 3-14 36 5z",
  clipPath: "url(#peee9962114)",
  fill: "#00a0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M701 414l-41-6 1-19 41 7z",
  clipPath: "url(#peee9962114)",
  fill: "#33ffc4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M452 454l-17 15-6-25 18-14z",
  clipPath: "url(#peee9962114)",
  fill: "#00b0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473 549l-7 16-13-16 8-16z",
  clipPath: "url(#peee9962114)",
  fill: "#0000c8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M485 562l-6 15-13-12 7-16z",
  clipPath: "url(#peee9962114)",
  fill: "#0000a4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M582 512l-12 10-6 9 14-10z",
  clipPath: "url(#peee9962114)",
  fill: "#0008ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M461 533l-8 16-11-19 9-16z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499 363l-31 7v-24l31-6z",
  clipPath: "url(#peee9962114)",
  fill: "#94ff63",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M705 503l-28 1 3-1 30-1z",
  clipPath: "url(#peee9962114)",
  fill: "#0034ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671 497l-26 3 1 5 28-3z",
  clipPath: "url(#peee9962114)",
  fill: "#003cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M469 394l-25 11-1-25 25-10z",
  clipPath: "url(#peee9962114)",
  fill: "#56ffa0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M498 571l-4 15-15-9 6-15z",
  clipPath: "url(#peee9962114)",
  fill: "#000089",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M644 493l-24 4-1 8 26-5z",
  clipPath: "url(#peee9962114)",
  fill: "#04f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734 452l-36-5 2-16 36 6z",
  clipPath: "url(#peee9962114)",
  fill: "#00c8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M661 370l-43-6v-20l43 7z",
  clipPath: "url(#peee9962114)",
  fill: "#90ff66",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M576 339l-40-1v-21l40 2z",
  clipPath: "url(#peee9962114)",
  fill: "#caff2c",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M554 543l-5 13-10 6 7-13z",
  clipPath: "url(#peee9962114)",
  fill: "#0000cd",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M451 514l-9 16-10-22 10-16z",
  clipPath: "url(#peee9962114)",
  fill: "#0028ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M536 338l-37 2 2-22 35-1z",
  clipPath: "url(#peee9962114)",
  fill: "#ceff29",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M618 344l-42-5v-20l42 6z",
  clipPath: "url(#peee9962114)",
  fill: "#c7ff30",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539 562l-3 13-12 3 4-14z",
  clipPath: "url(#peee9962114)",
  fill: "#00009f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M702 396l-41-7v-19l42 9z",
  clipPath: "url(#peee9962114)",
  fill: "#60ff97",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M701 500l-27 2 3 2 28-1z",
  clipPath: "url(#peee9962114)",
  fill: "#0040ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M570 522l-8 12-8 9 10-12z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M511 576l-3 15-14-5 4-15z",
  clipPath: "url(#peee9962114)",
  fill: "navy",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447 430l-18 14-3-26 18-13z",
  clipPath: "url(#peee9962114)",
  fill: "#16ffe1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M736 437l-36-6 1-17 37 8z",
  clipPath: "url(#peee9962114)",
  fill: "#0ff8e7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M620 486l-19 7-2 11 21-7z",
  clipPath: "url(#peee9962114)",
  fill: "#0058ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M601 493l-16 7-3 12 17-8z",
  clipPath: "url(#peee9962114)",
  fill: "#0048ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669 490l-25 3 1 7 26-3z",
  clipPath: "url(#peee9962114)",
  fill: "#0058ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M442 492l-10 17-8-24 11-16z",
  clipPath: "url(#peee9962114)",
  fill: "#0068ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747 496l-28-2 4-7 29 3z",
  clipPath: "url(#peee9962114)",
  fill: "#0060ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M741 501l-27-1 5-6 28 2z",
  clipPath: "url(#peee9962114)",
  fill: "#0054ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M752 490l-29-3 4-10 30 4z",
  clipPath: "url(#peee9962114)",
  fill: "#0074ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M642 482l-22 4v11l24-4z",
  clipPath: "url(#peee9962114)",
  fill: "#006cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M585 500l-10 10-5 12 12-10z",
  clipPath: "url(#peee9962114)",
  fill: "#0038ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M697 495l-26 2 3 5 27-2z",
  clipPath: "url(#peee9962114)",
  fill: "#0054ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M661 351l-43-7v-19l43 9z",
  clipPath: "url(#peee9962114)",
  fill: "#c1ff36",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524 578l-2 14-14-1 3-15z",
  clipPath: "url(#peee9962114)",
  fill: "#000084",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M468 370l-25 10v-25l25-9z",
  clipPath: "url(#peee9962114)",
  fill: "#97ff60",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M736 503l-26-1 4-2 27 1z",
  clipPath: "url(#peee9962114)",
  fill: "#004cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499 340l-31 6 2-23 31-5z",
  clipPath: "url(#peee9962114)",
  fill: "#d1ff26",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M757 481l-30-4 4-12 30 6z",
  clipPath: "url(#peee9962114)",
  fill: "#0090ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M739 422l-38-8 1-18 38 10z",
  clipPath: "url(#peee9962114)",
  fill: "#36ffc1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M703 379l-42-9v-19l42 11z",
  clipPath: "url(#peee9962114)",
  fill: "#8dff6a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M576 319l-40-2 2-20 39 4z",
  clipPath: "url(#peee9962114)",
  fill: "#ffea00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M562 534l-3 12-10 10 5-13z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M731 503h-26l5-1 26 1z",
  clipPath: "url(#peee9962114)",
  fill: "#0050ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M549 556l-1 13-12 6 3-13z",
  clipPath: "url(#peee9962114)",
  fill: "#0000c4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M761 471l-30-6 3-13 31 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00b0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M618 325l-42-6 1-18 42 7z",
  clipPath: "url(#peee9962114)",
  fill: "#fbf100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M667 480l-25 2 2 11 25-3z",
  clipPath: "url(#peee9962114)",
  fill: "#0080ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M536 317l-35 1 2-20 35-1z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M444 405l-18 13-2-25 19-13z",
  clipPath: "url(#peee9962114)",
  fill: "#53ffa4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M435 469l-11 16-7-25 12-16z",
  clipPath: "url(#peee9962114)",
  fill: "#00b0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M575 510l-6 11-7 13 8-12z",
  clipPath: "url(#peee9962114)",
  fill: "#002cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M694 488l-25 2 2 7 26-2z",
  clipPath: "url(#peee9962114)",
  fill: "#0070ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M479 577l-1 15-14-12 2-15z",
  clipPath: "url(#peee9962114)",
  fill: "#00009f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M466 565l-2 15-13-16 2-15z",
  clipPath: "url(#peee9962114)",
  fill: "#0000c8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M620 473l-18 5-1 15 19-7z",
  clipPath: "url(#peee9962114)",
  fill: "#008cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M726 500h-25l4 3h26z",
  clipPath: "url(#peee9962114)",
  fill: "#005cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M602 478l-14 7-3 15 16-7z",
  clipPath: "url(#peee9962114)",
  fill: "#007cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M765 459l-31-7 2-15 32 8z",
  clipPath: "url(#peee9962114)",
  fill: "#00d8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M494 586l-1 15-15-9 1-15z",
  clipPath: "url(#peee9962114)",
  fill: "#000089",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M536 575v14l-14 3 2-14z",
  clipPath: "url(#peee9962114)",
  fill: "#00009b",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M740 406l-38-10 1-17 38 11z",
  clipPath: "url(#peee9962114)",
  fill: "#63ff94",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M453 549l-2 15-12-18 3-16z",
  clipPath: "url(#peee9962114)",
  fill: "#0000fa",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M642 469l-22 4v13l22-4z",
  clipPath: "url(#peee9962114)",
  fill: "#009cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M661 334l-43-9 1-17 42 9z",
  clipPath: "url(#peee9962114)",
  fill: "#f1fc06",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M703 362l-42-11v-17l41 11z",
  clipPath: "url(#peee9962114)",
  fill: "#beff39",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M588 485l-9 9-4 16 10-10z",
  clipPath: "url(#peee9962114)",
  fill: "#0070ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M508 591v15l-15-5 1-15z",
  clipPath: "url(#peee9962114)",
  fill: "navy",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721 495h-24l4 5h25z",
  clipPath: "url(#peee9962114)",
  fill: "#006cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M468 346l-25 9 2-24 25-8z",
  clipPath: "url(#peee9962114)",
  fill: "#d4ff23",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M768 445l-32-8 2-15 33 9z",
  clipPath: "url(#peee9962114)",
  fill: "#19ffde",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M501 318l-31 5 3-21 30-4z",
  clipPath: "url(#peee9962114)",
  fill: "#ffdb00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M442 530l-3 16-10-22 3-16z",
  clipPath: "url(#peee9962114)",
  fill: "#0024ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M691 479l-24 1 2 10 25-2z",
  clipPath: "url(#peee9962114)",
  fill: "#0094ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M665 467l-23 2v13l25-2z",
  clipPath: "url(#peee9962114)",
  fill: "#00acff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M577 301l-39-4 2-17 38 5z",
  clipPath: "url(#peee9962114)",
  fill: "#ffb200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M429 444l-12 16-4-26 13-16z",
  clipPath: "url(#peee9962114)",
  fill: "#13fce4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M559 546v13l-11 10 1-13z",
  clipPath: "url(#peee9962114)",
  fill: "#0000f1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M619 308l-42-7 1-16 41 7z",
  clipPath: "url(#peee9962114)",
  fill: "#ffbd00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M569 521l-2 11-8 14 3-12z",
  clipPath: "url(#peee9962114)",
  fill: "#0020ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M741 390l-38-11v-17l38 12z",
  clipPath: "url(#peee9962114)",
  fill: "#8dff6a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M763 503l-22-2 6-5 22 3z",
  clipPath: "url(#peee9962114)",
  fill: "#006cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769 499l-22-3 5-6 23 4z",
  clipPath: "url(#peee9962114)",
  fill: "#0078ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M443 380l-19 13v-26l19-12z",
  clipPath: "url(#peee9962114)",
  fill: "#97ff60",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M757 505l-21-2 5-2 22 2z",
  clipPath: "url(#peee9962114)",
  fill: "#0068ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M775 494l-23-4 5-9 23 5z",
  clipPath: "url(#peee9962114)",
  fill: "#008cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M538 297l-35 1 4-18h33z",
  clipPath: "url(#peee9962114)",
  fill: "#ffa700",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M620 457l-17 4-1 17 18-5z",
  clipPath: "url(#peee9962114)",
  fill: "#00c4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M522 592l1 15-15-1v-15z",
  clipPath: "url(#peee9962114)",
  fill: "#000084",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M548 569l1 13-13 7v-14z",
  clipPath: "url(#peee9962114)",
  fill: "#00b",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M717 488h-23l3 7h24z",
  clipPath: "url(#peee9962114)",
  fill: "#0084ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M579 494l-5 10-5 17 6-11z",
  clipPath: "url(#peee9962114)",
  fill: "#0068ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M771 431l-33-9 2-16 32 10z",
  clipPath: "url(#peee9962114)",
  fill: "#3cffba",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M641 454l-21 3v16l22-4z",
  clipPath: "url(#peee9962114)",
  fill: "#00d0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M432 509l-3 15-9-23 4-16z",
  clipPath: "url(#peee9962114)",
  fill: "#0064ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M751 504l-20-1h5l21 2z",
  clipPath: "url(#peee9962114)",
  fill: "#0068ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M603 461l-13 7-2 17 14-7z",
  clipPath: "url(#peee9962114)",
  fill: "#00b8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M780 486l-23-5 4-10 24 6z",
  clipPath: "url(#peee9962114)",
  fill: "#00a4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M702 345l-41-11v-17l40 13z",
  clipPath: "url(#peee9962114)",
  fill: "#ebff0c",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M661 317l-42-9v-16l41 11z",
  clipPath: "url(#peee9962114)",
  fill: "#ffc800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M688 467h-23l2 13 24-1z",
  clipPath: "url(#peee9962114)",
  fill: "#00bcff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M746 501l-20-1 5 3 20 1z",
  clipPath: "url(#peee9962114)",
  fill: "#0074ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M785 477l-24-6 4-12 24 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00c4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M664 453l-23 1 1 15 23-2z",
  clipPath: "url(#peee9962114)",
  fill: "#00dcfe",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M590 468l-8 8-3 18 9-9z",
  clipPath: "url(#peee9962114)",
  fill: "#00b0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M741 374l-38-12-1-17 38 13z",
  clipPath: "url(#peee9962114)",
  fill: "#b7ff40",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M713 479h-22l3 9h23z",
  clipPath: "url(#peee9962114)",
  fill: "#00a4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M772 417l-32-11 1-16 32 12z",
  clipPath: "url(#peee9962114)",
  fill: "#63ff94",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M536 589l2 14-15 4-1-15z",
  clipPath: "url(#peee9962114)",
  fill: "#000096",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426 418l-13 16-2-26 13-15z",
  clipPath: "url(#peee9962114)",
  fill: "#53ffa4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M470 323l-25 8 4-21 24-8z",
  clipPath: "url(#peee9962114)",
  fill: "gold",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578 285l-38-5 3-14 37 5z",
  clipPath: "url(#peee9962114)",
  fill: "#ff7a00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M503 298l-30 4 5-19 29-3z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9c00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M619 292l-41-7 2-14 39 8z",
  clipPath: "url(#peee9962114)",
  fill: "#ff8900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M740 497l-19-2 5 5 20 1z",
  clipPath: "url(#peee9962114)",
  fill: "#0084ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M478 592l2 14-14-12-2-14z",
  clipPath: "url(#peee9962114)",
  fill: "#00009f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M789 466l-24-7 3-14 25 9z",
  clipPath: "url(#peee9962114)",
  fill: "#00e4f8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M464 580l2 14-13-16-2-14z",
  clipPath: "url(#peee9962114)",
  fill: "#0000c8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M567 532l1 12-9 15v-13z",
  clipPath: "url(#peee9962114)",
  fill: "#0018ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M424 485l-4 16-6-25 3-16z",
  clipPath: "url(#peee9962114)",
  fill: "#00acff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M493 601l2 14-15-9-2-14z",
  clipPath: "url(#peee9962114)",
  fill: "#000089",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M574 504v11l-7 17 2-11z",
  clipPath: "url(#peee9962114)",
  fill: "#005cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M621 439l-17 4-1 18 17-4z",
  clipPath: "url(#peee9962114)",
  fill: "#16ffe1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M559 559l3 12-12 11-2-13z",
  clipPath: "url(#peee9962114)",
  fill: "#0000ed",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M701 330l-40-13-1-14 40 13z",
  clipPath: "url(#peee9962114)",
  fill: "gold",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M641 437l-20 2-1 18 21-3z",
  clipPath: "url(#peee9962114)",
  fill: "#1cffdb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M443 355l-19 12 3-24 18-12z",
  clipPath: "url(#peee9962114)",
  fill: "#d7ff1f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M451 564l2 14-12-18-2-14z",
  clipPath: "url(#peee9962114)",
  fill: "#0000fa",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M686 454l-22-1 1 14h23z",
  clipPath: "url(#peee9962114)",
  fill: "#02e8f4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M540 280h-33l4-15 32 1z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6f00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M660 303l-41-11v-13l40 12z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604 443l-12 5-2 20 13-7z",
  clipPath: "url(#peee9962114)",
  fill: "#13fce4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M736 490l-19-2 4 7 19 2z",
  clipPath: "url(#peee9962114)",
  fill: "#009cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M582 476l-4 9-4 19 5-10z",
  clipPath: "url(#peee9962114)",
  fill: "#00a8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M710 469l-22-2 3 12h22z",
  clipPath: "url(#peee9962114)",
  fill: "#0cf",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M793 454l-25-9 3-14 24 10z",
  clipPath: "url(#peee9962114)",
  fill: "#1fffd7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M508 606l2 14-15-5-2-14z",
  clipPath: "url(#peee9962114)",
  fill: "navy",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M773 402l-32-12v-16l32 13z",
  clipPath: "url(#peee9962114)",
  fill: "#8dff6a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M740 358l-38-13-1-15 38 14z",
  clipPath: "url(#peee9962114)",
  fill: "#e1ff16",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M663 438l-22-1v17l23-1z",
  clipPath: "url(#peee9962114)",
  fill: "#23ffd4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M439 546l2 14-11-22-1-14z",
  clipPath: "url(#peee9962114)",
  fill: "#0024ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M778 506l-15-3 6-4 15 4z",
  clipPath: "url(#peee9962114)",
  fill: "#0084ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M550 582l1 14-13 7-2-14z",
  clipPath: "url(#peee9962114)",
  fill: "#00b",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M771 507l-14-2 6-2 15 3z",
  clipPath: "url(#peee9962114)",
  fill: "#0080ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M784 503l-15-4 6-5 15 5z",
  clipPath: "url(#peee9962114)",
  fill: "#0090ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M765 507l-14-3 6 1 14 2z",
  clipPath: "url(#peee9962114)",
  fill: "#0084ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M790 499l-15-5 5-8 16 6z",
  clipPath: "url(#peee9962114)",
  fill: "#00a0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M592 448l-8 7-2 21 8-8z",
  clipPath: "url(#peee9962114)",
  fill: "#0cf4eb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M417 460l-3 16-5-26 4-16z",
  clipPath: "url(#peee9962114)",
  fill: "#13fce4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M731 481l-18-2 4 9 19 2z",
  clipPath: "url(#peee9962114)",
  fill: "#00b8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M619 279l-39-8 2-11 37 9z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M795 441l-24-10 1-15 25 12z",
  clipPath: "url(#peee9962114)",
  fill: "#43ffb4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M424 393l-13 15 1-25 12-16z",
  clipPath: "url(#peee9962114)",
  fill: "#97ff60",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M523 607l2 14-15-1-2-14z",
  clipPath: "url(#peee9962114)",
  fill: "#000084",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M580 271l-37-5 4-12 35 6z",
  clipPath: "url(#peee9962114)",
  fill: "#ff4e00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M700 316l-40-13-1-12 39 13z",
  clipPath: "url(#peee9962114)",
  fill: "#ffab00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M759 504l-13-3 5 3 14 3z",
  clipPath: "url(#peee9962114)",
  fill: "#008cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M685 439l-22-1 1 15 22 1z",
  clipPath: "url(#peee9962114)",
  fill: "#2cffca",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M796 492l-16-6 5-9 16 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00b8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473 302l-24 8 6-20 23-7z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M507 280l-29 3 6-16 27-2z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M708 456l-22-2 2 13 22 2z",
  clipPath: "url(#peee9962114)",
  fill: "#0cf4eb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M640 419l-19 1v19l20-2z",
  clipPath: "url(#peee9962114)",
  fill: "#50ffa7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M621 420l-17 2v21l17-4z",
  clipPath: "url(#peee9962114)",
  fill: "#4dffaa",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M773 387l-32-13-1-16 32 15z",
  clipPath: "url(#peee9962114)",
  fill: "#b4ff43",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M574 515l2 12-8 17-1-12z",
  clipPath: "url(#peee9962114)",
  fill: "#0058ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M659 291l-40-12v-10l39 12z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6f00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M429 524l1 14-8-23-2-14z",
  clipPath: "url(#peee9962114)",
  fill: "#0068ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M739 344l-38-14-1-14 37 15z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M568 544l4 13-10 14-3-12z",
  clipPath: "url(#peee9962114)",
  fill: "#0014ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578 485l1 11-5 19v-11z",
  clipPath: "url(#peee9962114)",
  fill: "#00a0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M754 499l-14-2 6 4 13 3z",
  clipPath: "url(#peee9962114)",
  fill: "#009cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M662 421l-22-2 1 18 22 1z",
  clipPath: "url(#peee9962114)",
  fill: "#53ffa4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M801 484l-16-7 4-11 16 8z",
  clipPath: "url(#peee9962114)",
  fill: "#00d4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M543 266l-32-1 5-12 31 1z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3f00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M445 331l-18 12 5-22 17-11z",
  clipPath: "url(#peee9962114)",
  fill: "#ffd300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604 422l-12 4v22l12-5z",
  clipPath: "url(#peee9962114)",
  fill: "#49ffad",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M728 471l-18-2 3 10 18 2z",
  clipPath: "url(#peee9962114)",
  fill: "#00dcfe",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M797 428l-25-11 1-15 25 12z",
  clipPath: "url(#peee9962114)",
  fill: "#66ff90",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M584 455l-3 9-3 21 4-9z",
  clipPath: "url(#peee9962114)",
  fill: "#09f0ee",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M538 603l1 14-14 4-2-14z",
  clipPath: "url(#peee9962114)",
  fill: "#00009b",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M562 571l2 14-13 11-2-14z",
  clipPath: "url(#peee9962114)",
  fill: "#0000e8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M749 493l-13-3 4 7 14 2z",
  clipPath: "url(#peee9962114)",
  fill: "#00b0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M805 474l-16-8 4-12 16 9z",
  clipPath: "url(#peee9962114)",
  fill: "#0cf4eb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M706 443l-21-4 1 15 22 2z",
  clipPath: "url(#peee9962114)",
  fill: "#33ffc4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M685 424l-23-3 1 17 22 1z",
  clipPath: "url(#peee9962114)",
  fill: "#56ffa0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M619 269l-37-9 2-8 35 9z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3b00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M480 606l3 13-14-12-3-13z",
  clipPath: "url(#peee9962114)",
  fill: "#0000a8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M772 373l-32-15-1-14 31 15z",
  clipPath: "url(#peee9962114)",
  fill: "#d7ff1f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M698 304l-39-13-1-10 38 14z",
  clipPath: "url(#peee9962114)",
  fill: "#ff8600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M466 594l3 13-13-16-3-13z",
  clipPath: "url(#peee9962114)",
  fill: "#0000cd",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M413 434l-4 16-2-26 4-16z",
  clipPath: "url(#peee9962114)",
  fill: "#53ffa4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M592 426l-7 6-1 23 8-7z",
  clipPath: "url(#peee9962114)",
  fill: "#46ffb1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M582 260l-35-6 4-8 33 6z",
  clipPath: "url(#peee9962114)",
  fill: "#ff2900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M420 501l2 14-7-25-1-14z",
  clipPath: "url(#peee9962114)",
  fill: "#00b0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M641 400l-20-1v21l19-1z",
  clipPath: "url(#peee9962114)",
  fill: "#80ff77",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M495 615l2 12-14-8-3-13z",
  clipPath: "url(#peee9962114)",
  fill: "#000092",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M737 331l-37-15-2-12 36 16z",
  clipPath: "url(#peee9962114)",
  fill: "#ffb900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M621 399l-17 1v22l17-2z",
  clipPath: "url(#peee9962114)",
  fill: "#80ff77",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M725 460l-17-4 2 13 18 2z",
  clipPath: "url(#peee9962114)",
  fill: "#16ffe1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M658 281l-39-12v-8l37 13z",
  clipPath: "url(#peee9962114)",
  fill: "#ff4e00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M798 414l-25-12v-15l25 14z",
  clipPath: "url(#peee9962114)",
  fill: "#8aff6d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M424 367l-12 16 3-25 12-15z",
  clipPath: "url(#peee9962114)",
  fill: "#d7ff1f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M453 578l3 13-12-18-3-13z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M744 484l-13-3 5 9 13 3z",
  clipPath: "url(#peee9962114)",
  fill: "#00c8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M663 403l-22-3-1 19 22 2z",
  clipPath: "url(#peee9962114)",
  fill: "#80ff77",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M809 463l-16-9 2-13 17 11z",
  clipPath: "url(#peee9962114)",
  fill: "#29ffce",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M511 265l-27 2 7-12 25-2z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M478 283l-23 7 7-16 22-7z",
  clipPath: "url(#peee9962114)",
  fill: "#ff5900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M778 511l-7-4 7-1 6 4z",
  clipPath: "url(#peee9962114)",
  fill: "#0098ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M784 510l-6-4 6-3 7 5z",
  clipPath: "url(#peee9962114)",
  fill: "#009cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M510 620l2 12-15-5-2-12z",
  clipPath: "url(#peee9962114)",
  fill: "#000084",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M772 510l-7-3h6l7 4z",
  clipPath: "url(#peee9962114)",
  fill: "#0098ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604 400l-11 4-1 22 12-4z",
  clipPath: "url(#peee9962114)",
  fill: "#80ff77",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M791 508l-7-5 6-4 7 5z",
  clipPath: "url(#peee9962114)",
  fill: "#00a4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M579 496l4 11-7 20-2-12z",
  clipPath: "url(#peee9962114)",
  fill: "#009cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M551 596l2 14-14 7-1-14z",
  clipPath: "url(#peee9962114)",
  fill: "#00b",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M576 527l5 12-9 18-4-13z",
  clipPath: "url(#peee9962114)",
  fill: "#0054ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M547 254l-31-1 6-9 29 2z",
  clipPath: "url(#peee9962114)",
  fill: "#ff1600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M706 428l-21-4v15l21 4z",
  clipPath: "url(#peee9962114)",
  fill: "#5aff9d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M766 507l-7-3 6 3 7 3z",
  clipPath: "url(#peee9962114)",
  fill: "#00a0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M441 560l3 13-10-21-4-14z",
  clipPath: "url(#peee9962114)",
  fill: "#0028ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M581 464l2 9-4 23-1-11z",
  clipPath: "url(#peee9962114)",
  fill: "#06ecf1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M770 359l-31-15-2-13 31 17z",
  clipPath: "url(#peee9962114)",
  fill: "#fbf100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M685 408l-22-5-1 18 23 3z",
  clipPath: "url(#peee9962114)",
  fill: "#80ff77",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M797 504l-7-5 6-7 7 6z",
  clipPath: "url(#peee9962114)",
  fill: "#00b4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M741 475l-13-4 3 10 13 3z",
  clipPath: "url(#peee9962114)",
  fill: "#02e8f4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M696 295l-38-14-2-7 37 14z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M449 310l-17 11 6-20 17-11z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M812 452l-17-11 2-13 17 12z",
  clipPath: "url(#peee9962114)",
  fill: "#46ffb1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M724 447l-18-4 2 13 17 4z",
  clipPath: "url(#peee9962114)",
  fill: "#39ffbe",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M619 261l-35-9 2-4 34 9z",
  clipPath: "url(#peee9962114)",
  fill: "#f20",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M798 401l-25-14-1-14 25 15z",
  clipPath: "url(#peee9962114)",
  fill: "#adff49",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M585 432l-2 8-2 24 3-9z",
  clipPath: "url(#peee9962114)",
  fill: "#43ffb4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M760 502l-6-3 5 5 7 3z",
  clipPath: "url(#peee9962114)",
  fill: "#00b0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734 320l-36-16-2-9 35 16z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M572 557l3 13-11 15-2-14z",
  clipPath: "url(#peee9962114)",
  fill: "#0014ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M641 381l-20-3v21l20 1z",
  clipPath: "url(#peee9962114)",
  fill: "#b4ff43",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M803 498l-7-6 5-8 7 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00c8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M525 621l2 12-15-1-2-12z",
  clipPath: "url(#peee9962114)",
  fill: "#00008d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656 274l-37-13 1-4 35 13z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M414 476l1 14-4-26-2-14z",
  clipPath: "url(#peee9962114)",
  fill: "#13fce4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M663 385l-22-4v19l22 3z",
  clipPath: "url(#peee9962114)",
  fill: "#adff49",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M621 378h-17v22l17-1z",
  clipPath: "url(#peee9962114)",
  fill: "#b7ff40",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M584 252l-33-6 4-4 31 6z",
  clipPath: "url(#peee9962114)",
  fill: "#f60b00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M593 404l-8 5v23l7-6z",
  clipPath: "url(#peee9962114)",
  fill: "#80ff77",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M411 408l-4 16 1-26 4-15z",
  clipPath: "url(#peee9962114)",
  fill: "#97ff60",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M755 496l-6-3 5 6 6 3z",
  clipPath: "url(#peee9962114)",
  fill: "#00c0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M430 538l4 14-9-24-3-13z",
  clipPath: "url(#peee9962114)",
  fill: "#0068ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M738 464l-13-4 3 11 13 4z",
  clipPath: "url(#peee9962114)",
  fill: "#1fffd7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M808 491l-7-7 4-10 7 8z",
  clipPath: "url(#peee9962114)",
  fill: "#00e0fb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M706 413l-21-5v16l21 4z",
  clipPath: "url(#peee9962114)",
  fill: "#80ff77",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M814 440l-17-12 1-14 17 13z",
  clipPath: "url(#peee9962114)",
  fill: "#66ff90",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M768 348l-31-17-3-11 31 17z",
  clipPath: "url(#peee9962114)",
  fill: "#fc0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M686 391l-23-6v18l22 5z",
  clipPath: "url(#peee9962114)",
  fill: "#aaff4d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604 378l-12 2 1 24 11-4z",
  clipPath: "url(#peee9962114)",
  fill: "#baff3c",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M723 434l-17-6v15l18 4z",
  clipPath: "url(#peee9962114)",
  fill: "#5aff9d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M693 288l-37-14-1-4 35 14z",
  clipPath: "url(#peee9962114)",
  fill: "#ff4e00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M427 343l-12 15 5-23 12-14z",
  clipPath: "url(#peee9962114)",
  fill: "#ffd000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M797 388l-25-15-2-14 25 17z",
  clipPath: "url(#peee9962114)",
  fill: "#d1ff26",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M516 253l-25 2 7-9 24-2z",
  clipPath: "url(#peee9962114)",
  fill: "#f10800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M750 488l-6-4 5 9 6 3z",
  clipPath: "url(#peee9962114)",
  fill: "#00d8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564 585l1 14-12 11-2-14z",
  clipPath: "url(#peee9962114)",
  fill: "#0000ed",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M731 311l-35-16-3-7 34 17z",
  clipPath: "url(#peee9962114)",
  fill: "#ff7a00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M551 246l-29-2 7-4 26 2z",
  clipPath: "url(#peee9962114)",
  fill: "#df0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M642 362l-21-4v20l20 3z",
  clipPath: "url(#peee9962114)",
  fill: "#e4ff13",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M620 257l-34-9 2-1 32 10z",
  clipPath: "url(#peee9962114)",
  fill: "#fa0f00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M484 267l-22 7 9-13 20-6z",
  clipPath: "url(#peee9962114)",
  fill: "#ff2500",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M812 482l-7-8 4-11 7 10z",
  clipPath: "url(#peee9962114)",
  fill: "#16ffe1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539 617l2 13-14 3-2-12z",
  clipPath: "url(#peee9962114)",
  fill: "#00009f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M655 270l-35-13 33 12z",
  clipPath: "url(#peee9962114)",
  fill: "#ff2500",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M665 367l-23-5-1 19 22 4z",
  clipPath: "url(#peee9962114)",
  fill: "#dbff1c",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M621 358l-18-2 1 22h17z",
  clipPath: "url(#peee9962114)",
  fill: "#ebff0c",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M583 473l4 11-4 23-4-11z",
  clipPath: "url(#peee9962114)",
  fill: "#02e8f4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M736 453l-12-6 1 13 13 4z",
  clipPath: "url(#peee9962114)",
  fill: "#3cffba",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M583 507l5 11-7 21-5-12z",
  clipPath: "url(#peee9962114)",
  fill: "#0098ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M583 440l2 9-2 24-2-9z",
  clipPath: "url(#peee9962114)",
  fill: "#43ffb4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M586 248l-31-6 5-1 28 6z",
  clipPath: "url(#peee9962114)",
  fill: "#df0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M483 619l2 10-14-12-2-10z",
  clipPath: "url(#peee9962114)",
  fill: "#0000b2",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M815 427l-17-13v-13l17 14z",
  clipPath: "url(#peee9962114)",
  fill: "#8aff6d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M469 607l2 10-12-15-3-11z",
  clipPath: "url(#peee9962114)",
  fill: "#0000da",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M707 398l-21-7-1 17 21 5z",
  clipPath: "url(#peee9962114)",
  fill: "#a7ff50",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M585 409l-2 6v25l2-8z",
  clipPath: "url(#peee9962114)",
  fill: "#80ff77",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747 479l-6-4 3 9 6 4z",
  clipPath: "url(#peee9962114)",
  fill: "#0cf4eb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M776 515l2-4 6-1-2 5z",
  clipPath: "url(#peee9962114)",
  fill: "#00a8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M765 337l-31-17-3-9 30 18z",
  clipPath: "url(#peee9962114)",
  fill: "#ffab00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M422 515l3 13-6-24-4-14z",
  clipPath: "url(#peee9962114)",
  fill: "#00b0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M688 375l-23-8-2 18 23 6z",
  clipPath: "url(#peee9962114)",
  fill: "#d4ff23",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M770 514l2-4 6 1-2 4z",
  clipPath: "url(#peee9962114)",
  fill: "#00acff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M455 290l-17 11 8-17 16-10z",
  clipPath: "url(#peee9962114)",
  fill: "#f50",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M409 450l2 14-2-26-2-14z",
  clipPath: "url(#peee9962114)",
  fill: "#53ffa4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M497 627l3 11-15-9-2-10z",
  clipPath: "url(#peee9962114)",
  fill: "#00009b",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M690 284l-35-14-2-1 34 14z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3f00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M782 515l2-5 7-2-2 5z",
  clipPath: "url(#peee9962114)",
  fill: "#00acff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M592 380l-8 4 1 25 8-5z",
  clipPath: "url(#peee9962114)",
  fill: "#beff39",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M581 539l3 13-9 18-3-13z",
  clipPath: "url(#peee9962114)",
  fill: "#0050ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M723 420l-17-7v15l17 6z",
  clipPath: "url(#peee9962114)",
  fill: "#80ff77",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M816 473l-7-10 3-11 7 10z",
  clipPath: "url(#peee9962114)",
  fill: "#30ffc7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M795 376l-25-17-2-11 24 16z",
  clipPath: "url(#peee9962114)",
  fill: "#f1fc06",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M764 511l2-4 6 3-2 4z",
  clipPath: "url(#peee9962114)",
  fill: "#00b4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M456 591l3 11-12-18-3-11z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727 305l-34-17-3-4 33 17z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M789 513l2-5 6-4-2 6z",
  clipPath: "url(#peee9962114)",
  fill: "#00b8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643 343l-22-5v20l21 4z",
  clipPath: "url(#peee9962114)",
  fill: "gold",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M603 356l-13 1 2 23 12-2z",
  clipPath: "url(#peee9962114)",
  fill: "#f1fc06",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M620 257l-32-10 3 3 29 9z",
  clipPath: "url(#peee9962114)",
  fill: "#ed0400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M653 269l-33-12v2l32 12z",
  clipPath: "url(#peee9962114)",
  fill: "#ff1e00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M666 350l-23-7-1 19 23 5z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M758 506l2-4 6 5-2 4z",
  clipPath: "url(#peee9962114)",
  fill: "#00c0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M412 383l-4 15 3-25 4-15z",
  clipPath: "url(#peee9962114)",
  fill: "#d7ff1f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512 632l2 10-14-4-3-11z",
  clipPath: "url(#peee9962114)",
  fill: "#000092",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M621 338l-19-3 1 21 18 2z",
  clipPath: "url(#peee9962114)",
  fill: "#fc0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M795 510l2-6 6-6-3 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00c4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M736 441l-13-7 1 13 12 6z",
  clipPath: "url(#peee9962114)",
  fill: "#5dff9a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M744 469l-6-5 3 11 6 4z",
  clipPath: "url(#peee9962114)",
  fill: "#26ffd1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M815 415l-17-14-1-13 17 15z",
  clipPath: "url(#peee9962114)",
  fill: "#aaff4d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M555 242l-26-2 6-1 25 2z",
  clipPath: "url(#peee9962114)",
  fill: "#c80000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M553 610l2 13-14 7-2-13z",
  clipPath: "url(#peee9962114)",
  fill: "#0000c4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M753 500l2-4 5 6-2 4z",
  clipPath: "url(#peee9962114)",
  fill: "#00d0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M522 244l-24 2 9-5 22-1z",
  clipPath: "url(#peee9962114)",
  fill: "#cd0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M709 384l-21-9-2 16 21 7z",
  clipPath: "url(#peee9962114)",
  fill: "#ceff29",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M687 283l-34-14-1 2 32 14z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M690 359l-24-9-1 17 23 8z",
  clipPath: "url(#peee9962114)",
  fill: "#fbf100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M819 462l-7-10 2-12 7 11z",
  clipPath: "url(#peee9962114)",
  fill: "#4dffaa",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M444 573l3 11-10-21-3-11z",
  clipPath: "url(#peee9962114)",
  fill: "#0030ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M588 247l-28-6 4 4 27 5z",
  clipPath: "url(#peee9962114)",
  fill: "#d10000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M761 329l-30-18-4-6 29 17z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M575 570l1 14-11 15-1-14z",
  clipPath: "url(#peee9962114)",
  fill: "#0014ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M644 325l-23-6v19l22 5z",
  clipPath: "url(#peee9962114)",
  fill: "#ffa700",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M800 505l3-7 5-7-2 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00d8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M725 407l-18-9-1 15 17 7z",
  clipPath: "url(#peee9962114)",
  fill: "#a4ff53",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M723 301l-33-17-3-1 31 16z",
  clipPath: "url(#peee9962114)",
  fill: "#f50",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M792 364l-24-16-3-11 24 18z",
  clipPath: "url(#peee9962114)",
  fill: "#ffdb00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M652 271l-32-12v6l30 11z",
  clipPath: "url(#peee9962114)",
  fill: "#ff1e00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M432 321l-12 14 7-20 11-14z",
  clipPath: "url(#peee9962114)",
  fill: "#ff8d00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669 334l-25-9-1 18 23 7z",
  clipPath: "url(#peee9962114)",
  fill: "#ffb600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M620 259l-29-9 2 7 27 8z",
  clipPath: "url(#peee9962114)",
  fill: "#f10800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M491 255l-20 6 9-10 18-5z",
  clipPath: "url(#peee9962114)",
  fill: "#e40000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M749 493l1-5 5 8-2 4z",
  clipPath: "url(#peee9962114)",
  fill: "#02e8f4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M602 335l-14-1 2 23 13-1z",
  clipPath: "url(#peee9962114)",
  fill: "#ffc100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M621 319l-20-4 1 20 19 3z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M527 633l2 10-15-1-2-10z",
  clipPath: "url(#peee9962114)",
  fill: "#000096",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M590 357l-8 3 2 24 8-4z",
  clipPath: "url(#peee9962114)",
  fill: "#f8f500",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M742 459l-6-6 2 11 6 5z",
  clipPath: "url(#peee9962114)",
  fill: "#43ffb4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M415 490l4 14-4-26-4-14z",
  clipPath: "url(#peee9962114)",
  fill: "#13fce4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M684 285l-32-14-2 5 30 14z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M584 384l-3 6 2 25 2-6z",
  clipPath: "url(#peee9962114)",
  fill: "#c1ff36",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M736 428l-13-8v14l13 7z",
  clipPath: "url(#peee9962114)",
  fill: "#80ff77",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M645 310l-24-8v17l23 6z",
  clipPath: "url(#peee9962114)",
  fill: "#ff7e00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M806 498l2-7 4-9-2 9z",
  clipPath: "url(#peee9962114)",
  fill: "#09f0ee",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M583 415l2 9v25l-2-9z",
  clipPath: "url(#peee9962114)",
  fill: "#83ff73",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M693 345l-24-11-3 16 24 9z",
  clipPath: "url(#peee9962114)",
  fill: "#ffc400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M650 276l-30-11 1 10 27 10z",
  clipPath: "url(#peee9962114)",
  fill: "#ff2900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M585 449l4 10-2 25-4-11z",
  clipPath: "url(#peee9962114)",
  fill: "#40ffb7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671 320l-26-10-1 15 25 9z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M814 403l-17-15-2-12 16 16z",
  clipPath: "url(#peee9962114)",
  fill: "#caff2c",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M821 451l-7-11 1-13 7 13z",
  clipPath: "url(#peee9962114)",
  fill: "#6aff8d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M712 369l-22-10-2 16 21 9z",
  clipPath: "url(#peee9962114)",
  fill: "#f1fc06",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M587 484l6 11-5 23-5-11z",
  clipPath: "url(#peee9962114)",
  fill: "#00e4f8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M756 322l-29-17-4-4 28 17z",
  clipPath: "url(#peee9962114)",
  fill: "#ff7a00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M718 299l-31-16-3 2 30 16z",
  clipPath: "url(#peee9962114)",
  fill: "#ff4e00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M620 265l-27-8 2 10 26 8z",
  clipPath: "url(#peee9962114)",
  fill: "#ff1300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591 250l-27-5 5 7 24 5z",
  clipPath: "url(#peee9962114)",
  fill: "#d60000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M647 296l-26-9v15l24 8z",
  clipPath: "url(#peee9962114)",
  fill: "#ff5900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M407 424l2 14 1-25-2-15z",
  clipPath: "url(#peee9962114)",
  fill: "#97ff60",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M648 285l-27-10v12l26 9z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3b00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434 552l3 11-8-22-4-13z",
  clipPath: "url(#peee9962114)",
  fill: "#0070ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M745 484l2-5 3 9-1 5z",
  clipPath: "url(#peee9962114)",
  fill: "#16ffe1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M680 290l-30-14-2 9 29 12z",
  clipPath: "url(#peee9962114)",
  fill: "#ff4300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M621 302l-22-6 2 19 20 4z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6c00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M674 307l-27-11-2 14 26 10z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6f00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727 393l-18-9-2 14 18 9z",
  clipPath: "url(#peee9962114)",
  fill: "#c7ff30",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M462 274l-16 10 10-14 15-9z",
  clipPath: "url(#peee9962114)",
  fill: "#ff1e00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M560 241l-25-2 8 3 21 3z",
  clipPath: "url(#peee9962114)",
  fill: "#b00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M789 355l-24-18-4-8 23 18z",
  clipPath: "url(#peee9962114)",
  fill: "#ffbd00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M677 297l-29-12-1 11 27 11z",
  clipPath: "url(#peee9962114)",
  fill: "#f50",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M588 518l3 13-7 21-3-13z",
  clipPath: "url(#peee9962114)",
  fill: "#0098ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M621 275l-26-8 2 13 24 7z",
  clipPath: "url(#peee9962114)",
  fill: "#ff2900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M621 287l-24-7 2 16 22 6z",
  clipPath: "url(#peee9962114)",
  fill: "#ff4700",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M697 332l-26-12-2 14 24 11z",
  clipPath: "url(#peee9962114)",
  fill: "#ffa300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M601 315l-16-2 3 21 14 1z",
  clipPath: "url(#peee9962114)",
  fill: "#ff8900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M810 491l2-9 4-9-2 9z",
  clipPath: "url(#peee9962114)",
  fill: "#1cffdb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M714 301l-30-16-4 5 29 15z",
  clipPath: "url(#peee9962114)",
  fill: "#ff5200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M741 448l-5-7v12l6 6z",
  clipPath: "url(#peee9962114)",
  fill: "#60ff97",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M760 519l10-5 6 1-10 5z",
  clipPath: "url(#peee9962114)",
  fill: "#00bcff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M529 240l-22 1 9-1 19-1z",
  clipPath: "url(#peee9962114)",
  fill: "#b20000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M766 520l10-5h6l-10 5z",
  clipPath: "url(#peee9962114)",
  fill: "#00b8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565 599l2 13-12 11-2-13z",
  clipPath: "url(#peee9962114)",
  fill: "#0000f1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M754 515l10-4 6 3-10 5z",
  clipPath: "url(#peee9962114)",
  fill: "#00c4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M715 356l-22-11-3 14 22 10z",
  clipPath: "url(#peee9962114)",
  fill: "gold",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M737 416l-12-9-2 13 13 8z",
  clipPath: "url(#peee9962114)",
  fill: "#a0ff56",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M751 318l-28-17-5-2 28 18z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6f00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M593 257l-24-5 5 10 21 5z",
  clipPath: "url(#peee9962114)",
  fill: "#e40000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M700 320l-26-13-3 13 26 12z",
  clipPath: "url(#peee9962114)",
  fill: "#ff8200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M415 358l-4 15 5-23 4-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ffd000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M541 630l2 10-14 3-2-10z",
  clipPath: "url(#peee9962114)",
  fill: "#0000a8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M588 334l-9 2 3 24 8-3z",
  clipPath: "url(#peee9962114)",
  fill: "#ffb900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M743 475l1-6 3 10-2 5z",
  clipPath: "url(#peee9962114)",
  fill: "#30ffc7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M772 520l10-5 7-2-11 6z",
  clipPath: "url(#peee9962114)",
  fill: "#00bcff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M822 440l-7-13v-12l7 14z",
  clipPath: "url(#peee9962114)",
  fill: "#87ff70",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M709 305l-29-15-3 7 28 14z",
  clipPath: "url(#peee9962114)",
  fill: "#ff5900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M811 392l-16-16-3-12 16 17z",
  clipPath: "url(#peee9962114)",
  fill: "#e7ff0f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M749 511l9-5 6 5-10 4z",
  clipPath: "url(#peee9962114)",
  fill: "#00d0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M705 311l-28-14-3 10 26 13z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6c00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M599 296l-17-3 3 20 16 2z",
  clipPath: "url(#peee9962114)",
  fill: "#ff5d00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M485 629l2 8-13-12-3-8z",
  clipPath: "url(#peee9962114)",
  fill: "#0000c4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M730 381l-18-12-3 15 18 9z",
  clipPath: "url(#peee9962114)",
  fill: "#e7ff0f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M778 519l11-6 6-3-11 6z",
  clipPath: "url(#peee9962114)",
  fill: "#00c4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M784 347l-23-18-5-7 23 19z",
  clipPath: "url(#peee9962114)",
  fill: "#ffa700",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M595 267l-21-5 4 14 19 4z",
  clipPath: "url(#peee9962114)",
  fill: "#ff1300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M471 617l3 8-13-14-2-9z",
  clipPath: "url(#peee9962114)",
  fill: "#0000e8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M814 482l2-9 3-11-2 11z",
  clipPath: "url(#peee9962114)",
  fill: "#36ffc1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M744 505l9-5 5 6-9 5z",
  clipPath: "url(#peee9962114)",
  fill: "#00e0fb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M597 280l-19-4 4 17 17 3z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M582 360l-4 5 3 25 3-6z",
  clipPath: "url(#peee9962114)",
  fill: "#fbf100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M584 552l2 14-10 18-1-14z",
  clipPath: "url(#peee9962114)",
  fill: "#0054ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M498 246l-18 5 11-5 16-5z",
  clipPath: "url(#peee9962114)",
  fill: "#b00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564 245l-21-3 7 8 19 2z",
  clipPath: "url(#peee9962114)",
  fill: "#bf0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720 345l-23-13-4 13 22 11z",
  clipPath: "url(#peee9962114)",
  fill: "#ffb600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M746 317l-28-18-4 2 26 17z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M500 638l1 7-14-8-2-8z",
  clipPath: "url(#peee9962114)",
  fill: "#0000ad",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M425 528l4 13-6-24-4-13z",
  clipPath: "url(#peee9962114)",
  fill: "#00b4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M411 464l4 14-2-25-4-15z",
  clipPath: "url(#peee9962114)",
  fill: "#53ffa4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M742 436l-6-8v13l5 7z",
  clipPath: "url(#peee9962114)",
  fill: "#7dff7a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M438 301l-11 14 10-18 9-13z",
  clipPath: "url(#peee9962114)",
  fill: "#ff4e00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M784 516l11-6 5-5-10 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00d4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M459 602l2 9-11-18-3-9z",
  clipPath: "url(#peee9962114)",
  fill: "#0004ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M741 465l1-6 2 10-1 6z",
  clipPath: "url(#peee9962114)",
  fill: "#49ffad",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M581 390l2 8 2 26-2-9z",
  clipPath: "url(#peee9962114)",
  fill: "#c1ff36",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M740 498l9-5 4 7-9 5z",
  clipPath: "url(#peee9962114)",
  fill: "#0cf4eb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M739 404l-12-11-2 14 12 9z",
  clipPath: "url(#peee9962114)",
  fill: "#c1ff36",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M724 335l-24-15-3 12 23 13z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M585 313l-11 1 5 22 9-2z",
  clipPath: "url(#peee9962114)",
  fill: "#ff7e00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M740 318l-26-17-5 4 26 16z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6c00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M822 429l-7-14-1-12 7 14z",
  clipPath: "url(#peee9962114)",
  fill: "#a7ff50",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M808 381l-16-17-3-9 15 17z",
  clipPath: "url(#peee9962114)",
  fill: "#ffea00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734 369l-19-13-3 13 18 12z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M779 341l-23-19-5-4 23 19z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M585 424l4 9v26l-4-10z",
  clipPath: "url(#peee9962114)",
  fill: "#83ff73",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M729 327l-24-16-5 9 24 15z",
  clipPath: "url(#peee9962114)",
  fill: "#ff8200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M735 321l-26-16-4 6 24 16z",
  clipPath: "url(#peee9962114)",
  fill: "#ff7300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M514 642l1 8-14-5-1-7z",
  clipPath: "url(#peee9962114)",
  fill: "#0000a4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M535 239l-19 1 10 4 17-2z",
  clipPath: "url(#peee9962114)",
  fill: "#a40000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M817 473l2-11 2-11-3 12z",
  clipPath: "url(#peee9962114)",
  fill: "#50ffa7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M790 512l10-7 6-7-11 8z",
  clipPath: "url(#peee9962114)",
  fill: "#00e4f8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M569 252l-19-2 7 11 17 1z",
  clipPath: "url(#peee9962114)",
  fill: "#cd0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M589 459l6 10-2 26-6-11z",
  clipPath: "url(#peee9962114)",
  fill: "#40ffb7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M736 490l9-6 4 9-9 5z",
  clipPath: "url(#peee9962114)",
  fill: "#1fffd7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M408 398l2 15 3-25-2-15z",
  clipPath: "url(#peee9962114)",
  fill: "#d7ff1f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M471 261l-15 9 12-10 12-9z",
  clipPath: "url(#peee9962114)",
  fill: "#da0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M555 623l1 10-13 7-2-10z",
  clipPath: "url(#peee9962114)",
  fill: "#0000cd",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447 584l3 9-10-20-3-10z",
  clipPath: "url(#peee9962114)",
  fill: "#003cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M582 293h-13l5 21 11-1z",
  clipPath: "url(#peee9962114)",
  fill: "#ff4e00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M743 425l-6-9-1 12 6 8z",
  clipPath: "url(#peee9962114)",
  fill: "#9dff5a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M740 455l1-7 1 11-1 6z",
  clipPath: "url(#peee9962114)",
  fill: "#63ff94",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M574 262l-17-1 6 15h15z",
  clipPath: "url(#peee9962114)",
  fill: "#e80000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M739 358l-19-13-5 11 19 13z",
  clipPath: "url(#peee9962114)",
  fill: "#ffc400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M579 336l-5 4 4 25 4-5z",
  clipPath: "url(#peee9962114)",
  fill: "#ffae00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M774 337l-23-19-5-1 22 18z",
  clipPath: "url(#peee9962114)",
  fill: "#ff8600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M743 392l-13-11-3 12 12 11z",
  clipPath: "url(#peee9962114)",
  fill: "#deff19",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M593 495l3 12-5 24-3-13z",
  clipPath: "url(#peee9962114)",
  fill: "#00e4f8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578 276h-15l6 17h13z",
  clipPath: "url(#peee9962114)",
  fill: "#f20",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M576 584l2 13-11 15-2-13z",
  clipPath: "url(#peee9962114)",
  fill: "#0018ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M804 372l-15-17-5-8 16 17z",
  clipPath: "url(#peee9962114)",
  fill: "#ffd000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M795 506l11-8 4-7-11 8z",
  clipPath: "url(#peee9962114)",
  fill: "#0ff8e7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M821 417l-7-14-3-11 7 15z",
  clipPath: "url(#peee9962114)",
  fill: "#c1ff36",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M733 481l10-6 2 9-9 6z",
  clipPath: "url(#peee9962114)",
  fill: "#33ffc4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M529 643v8l-14-1-1-8z",
  clipPath: "url(#peee9962114)",
  fill: "#0000a8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818 463l3-12 1-11-3 12z",
  clipPath: "url(#peee9962114)",
  fill: "#6aff8d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M507 241l-16 5 11-1 14-5z",
  clipPath: "url(#peee9962114)",
  fill: "#9f0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M742 524l18-5 6 1-18 6z",
  clipPath: "url(#peee9962114)",
  fill: "#00c8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M744 350l-20-15-4 10 19 13z",
  clipPath: "url(#peee9962114)",
  fill: "#ffab00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M737 521l17-6 6 4-18 5z",
  clipPath: "url(#peee9962114)",
  fill: "#00d0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M768 335l-22-18-6 1 22 17z",
  clipPath: "url(#peee9962114)",
  fill: "#ff8200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M419 504l4 13-4-25-4-14z",
  clipPath: "url(#peee9962114)",
  fill: "#16ffe1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M420 335l-4 15 8-20 3-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ff8d00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M748 526l18-6h6l-18 6z",
  clipPath: "url(#peee9962114)",
  fill: "#00c8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M732 516l17-5 5 4-17 6z",
  clipPath: "url(#peee9962114)",
  fill: "#00d8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M543 242l-17 2 9 7 15-1z",
  clipPath: "url(#peee9962114)",
  fill: "#a80000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578 365l1 7 4 26-2-8z",
  clipPath: "url(#peee9962114)",
  fill: "#feed00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M749 343l-20-16-5 8 20 15z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M762 335l-22-17-5 3 20 17z",
  clipPath: "url(#peee9962114)",
  fill: "#ff8200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M740 444l2-8-1 12-1 7z",
  clipPath: "url(#peee9962114)",
  fill: "#7dff7a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M745 414l-6-10-2 12 6 9z",
  clipPath: "url(#peee9962114)",
  fill: "#baff3c",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747 382l-13-13-4 12 13 11z",
  clipPath: "url(#peee9962114)",
  fill: "#fbf100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M754 526l18-6 6-1-18 6z",
  clipPath: "url(#peee9962114)",
  fill: "#00c8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M799 499l11-8 4-9-12 9z",
  clipPath: "url(#peee9962114)",
  fill: "#26ffd1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727 510l17-5 5 6-17 5z",
  clipPath: "url(#peee9962114)",
  fill: "#02e8f4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M437 563l3 10-8-22-3-10z",
  clipPath: "url(#peee9962114)",
  fill: "#0078ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M755 338l-20-17-6 6 20 16z",
  clipPath: "url(#peee9962114)",
  fill: "#ff8900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M800 364l-16-17-5-6 15 18z",
  clipPath: "url(#peee9962114)",
  fill: "#ffb900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591 531l2 14-7 21-2-14z",
  clipPath: "url(#peee9962114)",
  fill: "#0098ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M409 438l4 15v-26l-3-14z",
  clipPath: "url(#peee9962114)",
  fill: "#97ff60",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M574 314l-6 3 6 23 5-4z",
  clipPath: "url(#peee9962114)",
  fill: "#ff7300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M732 472l9-7 2 10-10 6z",
  clipPath: "url(#peee9962114)",
  fill: "#4dffaa",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818 407l-7-15-3-11 7 16z",
  clipPath: "url(#peee9962114)",
  fill: "#deff19",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M446 284l-9 13 11-14 8-13z",
  clipPath: "url(#peee9962114)",
  fill: "#ff1a00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M760 525l18-6 6-3-18 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00d0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M723 503l17-5 4 7-17 5z",
  clipPath: "url(#peee9962114)",
  fill: "#13fce4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M819 452l3-12v-11l-3 13z",
  clipPath: "url(#peee9962114)",
  fill: "#87ff70",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M583 398l4 8 2 27-4-9z",
  clipPath: "url(#peee9962114)",
  fill: "#c4ff33",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M550 250l-15 1 9 12 13-2z",
  clipPath: "url(#peee9962114)",
  fill: "#b60000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M752 372l-13-14-5 11 13 13z",
  clipPath: "url(#peee9962114)",
  fill: "gold",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M794 359l-15-18-5-4 15 18z",
  clipPath: "url(#peee9962114)",
  fill: "#ffa700",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M567 612l1 10-12 11-1-10z",
  clipPath: "url(#peee9962114)",
  fill: "#0000fa",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M543 640v8l-14 3v-8z",
  clipPath: "url(#peee9962114)",
  fill: "#00b",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M802 491l12-9 3-9-12 9z",
  clipPath: "url(#peee9962114)",
  fill: "#3cffba",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M766 523l18-7 6-4-19 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00dcfe",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M749 404l-6-12-4 12 6 10z",
  clipPath: "url(#peee9962114)",
  fill: "#d4ff23",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M569 293l-8 3 7 21 6-3z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3f00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M742 434l1-9-1 11-2 8z",
  clipPath: "url(#peee9962114)",
  fill: "#9aff5d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M480 251l-12 9 12-6 11-8z",
  clipPath: "url(#peee9962114)",
  fill: "#b20000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M487 637l1 5-13-11-1-6z",
  clipPath: "url(#peee9962114)",
  fill: "#0000d6",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M719 495l17-5 4 8-17 5z",
  clipPath: "url(#peee9962114)",
  fill: "#26ffd1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M474 625l1 6-12-14-2-6z",
  clipPath: "url(#peee9962114)",
  fill: "#0000fa",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M731 462l9-7 1 10-9 7z",
  clipPath: "url(#peee9962114)",
  fill: "#63ff94",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M589 433l6 10v26l-6-10z",
  clipPath: "url(#peee9962114)",
  fill: "#83ff73",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M557 261l-13 2 9 15 10-2z",
  clipPath: "url(#peee9962114)",
  fill: "#d60000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M516 240l-14 5 12 3 12-4z",
  clipPath: "url(#peee9962114)",
  fill: "#960000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M815 397l-7-16-4-9 7 17z",
  clipPath: "url(#peee9962114)",
  fill: "#f4f802",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M563 276l-10 2 8 18 8-3z",
  clipPath: "url(#peee9962114)",
  fill: "#ff1300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M501 645v5l-13-8-1-5z",
  clipPath: "url(#peee9962114)",
  fill: "#0000bf",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M757 365l-13-15-5 8 13 14z",
  clipPath: "url(#peee9962114)",
  fill: "#ffc100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M411 373l2 15 5-23-2-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ffd000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M789 355l-15-18-6-2 14 18z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9c00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M819 442l3-13-1-12-3 14z",
  clipPath: "url(#peee9962114)",
  fill: "#a0ff56",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M574 340l-1 6 6 26-1-7z",
  clipPath: "url(#peee9962114)",
  fill: "#ffab00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M461 611l2 6-11-17-2-7z",
  clipPath: "url(#peee9962114)",
  fill: "#0014ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M771 519l19-7 5-6-19 8z",
  clipPath: "url(#peee9962114)",
  fill: "#06ecf1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M429 541l3 10-6-23-3-11z",
  clipPath: "url(#peee9962114)",
  fill: "#00bcff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M586 566l1 13-9 18-2-13z",
  clipPath: "url(#peee9962114)",
  fill: "#0054ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M717 487l16-6 3 9-17 5z",
  clipPath: "url(#peee9962114)",
  fill: "#39ffbe",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M763 359l-14-16-5 7 13 15z",
  clipPath: "url(#peee9962114)",
  fill: "#ffae00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M595 469l4 13-3 25-3-12z",
  clipPath: "url(#peee9962114)",
  fill: "#40ffb7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M782 353l-14-18h-6l14 18z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M415 478l4 14-2-25-4-14z",
  clipPath: "url(#peee9962114)",
  fill: "#56ffa0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M805 482l12-9 1-10-11 10z",
  clipPath: "url(#peee9962114)",
  fill: "#53ffa4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M753 394l-6-12-4 10 6 12z",
  clipPath: "url(#peee9962114)",
  fill: "#eeff09",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769 355l-14-17-6 5 14 16z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9f00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M776 353l-14-18-7 3 14 17z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M744 424l1-10-2 11-1 9z",
  clipPath: "url(#peee9962114)",
  fill: "#b4ff43",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M515 650v4l-14-4v-5z",
  clipPath: "url(#peee9962114)",
  fill: "#0000b6",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M713 526l24-5 5 3-23 6z",
  clipPath: "url(#peee9962114)",
  fill: "#00d8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M811 389l-7-17-4-8 6 17z",
  clipPath: "url(#peee9962114)",
  fill: "#ffde00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M731 452l9-8v11l-9 7z",
  clipPath: "url(#peee9962114)",
  fill: "#7dff7a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M719 530l23-6 6 2-24 6z",
  clipPath: "url(#peee9962114)",
  fill: "#00d0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M708 522l24-6 5 5-24 5z",
  clipPath: "url(#peee9962114)",
  fill: "#00e0fb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M724 532l24-6h6l-24 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00d0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M427 315l-3 15 10-18 3-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ff4e00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M704 516l23-6 5 6-24 6z",
  clipPath: "url(#peee9962114)",
  fill: "#09f0ee",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M776 514l19-8 4-7-19 8z",
  clipPath: "url(#peee9962114)",
  fill: "#19ffde",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M450 593l2 7-9-20-3-7z",
  clipPath: "url(#peee9962114)",
  fill: "#0048ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M715 478l17-6 1 9-16 6z",
  clipPath: "url(#peee9962114)",
  fill: "#50ffa7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818 431l3-14-3-10-2 14z",
  clipPath: "url(#peee9962114)",
  fill: "#beff39",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 244l-12 4 12 8 9-5z",
  clipPath: "url(#peee9962114)",
  fill: "#960000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M758 386l-6-14-5 10 6 12z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M556 633v8l-13 7v-8z",
  clipPath: "url(#peee9962114)",
  fill: "#0000da",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M730 533l24-7 6-1-25 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00d0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M579 372l4 8 4 26-4-8z",
  clipPath: "url(#peee9962114)",
  fill: "#ffea00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M700 509l23-6 4 7-23 6z",
  clipPath: "url(#peee9962114)",
  fill: "#16ffe1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M568 317l-2 6 7 23 1-6z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6c00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M410 413l3 14 3-24-3-15z",
  clipPath: "url(#peee9962114)",
  fill: "#d7ff1f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M807 473l11-10 1-11-11 11z",
  clipPath: "url(#peee9962114)",
  fill: "#6dff8a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M456 270l-8 13 12-11 8-12z",
  clipPath: "url(#peee9962114)",
  fill: "#d10000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M806 381l-6-17-6-5 7 17z",
  clipPath: "url(#peee9962114)",
  fill: "#fc0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M596 507l2 15-5 23-2-14z",
  clipPath: "url(#peee9962114)",
  fill: "#00e4f8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747 415l2-11-4 10-1 10z",
  clipPath: "url(#peee9962114)",
  fill: "#ceff29",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M491 246l-11 8 14-1 8-8z",
  clipPath: "url(#peee9962114)",
  fill: "#960000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M732 443l10-9-2 10-9 8z",
  clipPath: "url(#peee9962114)",
  fill: "#97ff60",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M529 651l-1 4-13-1v-4z",
  clipPath: "url(#peee9962114)",
  fill: "#00b",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M735 532l25-7 6-2-25 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00d8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578 597l1 11-11 14-1-10z",
  clipPath: "url(#peee9962114)",
  fill: "#0020ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M780 507l19-8 3-8-19 9zm-83-6l22-6 4 8-23 6z",
  clipPath: "url(#peee9962114)",
  fill: "#29ffce",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M763 379l-6-14-5 7 6 14z",
  clipPath: "url(#peee9962114)",
  fill: "#ffd000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M714 469l17-7 1 10-17 6z",
  clipPath: "url(#peee9962114)",
  fill: "#66ff90",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M816 421l2-14-3-10-2 15z",
  clipPath: "url(#peee9962114)",
  fill: "#d4ff23",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M801 376l-7-17-5-4 6 17z",
  clipPath: "url(#peee9962114)",
  fill: "#ffb900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M535 251l-9 5 11 11 7-4z",
  clipPath: "url(#peee9962114)",
  fill: "#a80000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M423 517l3 11-4-24-3-12z",
  clipPath: "url(#peee9962114)",
  fill: "#19ffde",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M587 406l6 10 2 27-6-10z",
  clipPath: "url(#peee9962114)",
  fill: "#c4ff33",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M561 296l-3 5 8 22 2-6z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M440 573l3 7-8-21-3-8z",
  clipPath: "url(#peee9962114)",
  fill: "#0080ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769 374l-6-15-6 6 6 14z",
  clipPath: "url(#peee9962114)",
  fill: "#ffc100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M741 530l25-7 5-4-25 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00e4f8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M808 463l11-11v-10l-11 12z",
  clipPath: "url(#peee9962114)",
  fill: "#87ff70",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M694 493l23-6 2 8-22 6z",
  clipPath: "url(#peee9962114)",
  fill: "#3cffba",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M751 406l2-12-4 10-2 11z",
  clipPath: "url(#peee9962114)",
  fill: "#e4ff13",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M795 372l-6-17-7-2 7 17z",
  clipPath: "url(#peee9962114)",
  fill: "#ffb200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M544 263l-7 4 11 16 5-5z",
  clipPath: "url(#peee9962114)",
  fill: "#c80000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M553 278l-5 5 10 18 3-5z",
  clipPath: "url(#peee9962114)",
  fill: "#f10800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734 433l10-9-2 10-10 9z",
  clipPath: "url(#peee9962114)",
  fill: "#b1ff46",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M776 371l-7-16-6 4 6 15z",
  clipPath: "url(#peee9962114)",
  fill: "#ffb200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M416 350l2 15 8-21-2-14z",
  clipPath: "url(#peee9962114)",
  fill: "#ff8d00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M783 500l19-9 3-9-19 10z",
  clipPath: "url(#peee9962114)",
  fill: "#40ffb7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M789 370l-7-17h-6l6 16z",
  clipPath: "url(#peee9962114)",
  fill: "#ffab00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M782 369l-6-16-7 2 7 16z",
  clipPath: "url(#peee9962114)",
  fill: "#ffae00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M715 460l16-8v10l-17 7z",
  clipPath: "url(#peee9962114)",
  fill: "#7dff7a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M685 533l28-7 6 4-29 6z",
  clipPath: "url(#peee9962114)",
  fill: "#00dcfe",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M680 528l28-6 5 4-28 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00e4f8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M413 453l4 14v-25l-4-15z",
  clipPath: "url(#peee9962114)",
  fill: "#97ff60",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M813 412l2-15-4-8-2 15z",
  clipPath: "url(#peee9962114)",
  fill: "#ebff0c",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M488 642l-1 2-12-11v-2z",
  clipPath: "url(#peee9962114)",
  fill: "#0000ed",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M593 545l1 13-7 21-1-13z",
  clipPath: "url(#peee9962114)",
  fill: "#009cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M595 443l4 13v26l-4-13z",
  clipPath: "url(#peee9962114)",
  fill: "#83ff73",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M690 536l29-6 5 2-29 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00d4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475 631v2l-12-13v-3z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573 346l3 9 7 25-4-8z",
  clipPath: "url(#peee9962114)",
  fill: "#ffa300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M676 522l28-6 4 6-28 6zm70 4l25-7 5-5-26 7z",
  clipPath: "url(#peee9962114)",
  fill: "#0cf4eb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M543 648l-2 4-13 3 1-4z",
  clipPath: "url(#peee9962114)",
  fill: "#0000cd",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M692 484l23-6 2 9-23 6z",
  clipPath: "url(#peee9962114)",
  fill: "#50ffa7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M501 650l-1 2-13-8 1-2z",
  clipPath: "url(#peee9962114)",
  fill: "#0000d6",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M756 399l2-13-5 8-2 12z",
  clipPath: "url(#peee9962114)",
  fill: "#f8f500",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M695 539l29-7 6 1-30 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00d4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M502 245l-8 8 13 3 7-8z",
  clipPath: "url(#peee9962114)",
  fill: "#890000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M672 515l28-6 4 7-28 6z",
  clipPath: "url(#peee9962114)",
  fill: "#19ffde",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M568 622v8l-12 11v-8z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M808 454l11-12-1-11-12 13z",
  clipPath: "url(#peee9962114)",
  fill: "#a0ff56",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M463 617v3l-10-16-1-4z",
  clipPath: "url(#peee9962114)",
  fill: "#0024ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M437 297l-3 15 11-15 3-14z",
  clipPath: "url(#peee9962114)",
  fill: "#ff1600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M738 425l9-10-3 9-10 9z",
  clipPath: "url(#peee9962114)",
  fill: "#c7ff30",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M809 404l2-15-5-8-2 16z",
  clipPath: "url(#peee9962114)",
  fill: "#feed00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M786 492l19-10 2-9-20 10z",
  clipPath: "url(#peee9962114)",
  fill: "#56ffa0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M468 260l-8 12 14-6 6-12z",
  clipPath: "url(#peee9962114)",
  fill: "#a80000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M700 540l30-7 5-1-29 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00d4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M716 450l16-7-1 9-16 8z",
  clipPath: "url(#peee9962114)",
  fill: "#97ff60",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669 507l28-6 3 8-28 6z",
  clipPath: "url(#peee9962114)",
  fill: "#29ffce",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M432 551l3 8-6-22-3-9z",
  clipPath: "url(#peee9962114)",
  fill: "#00c4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M750 521l26-7 4-7-26 8z",
  clipPath: "url(#peee9962114)",
  fill: "#1cffdb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M515 654l-2 2-13-4 1-2z",
  clipPath: "url(#peee9962114)",
  fill: "#0000cd",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M692 475l22-6 1 9-23 6z",
  clipPath: "url(#peee9962114)",
  fill: "#66ff90",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M761 393l2-14-5 7-2 13z",
  clipPath: "url(#peee9962114)",
  fill: "#ffde00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M413 388l3 15 5-23-3-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ffd300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M599 482l1 15-2 25-2-15z",
  clipPath: "url(#peee9962114)",
  fill: "#40ffb7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M706 539l29-7 6-2-30 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00dcfe",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M804 397l2-16-5-5-2 16z",
  clipPath: "url(#peee9962114)",
  fill: "#ffdb00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M806 444l12-13-2-10-12 14z",
  clipPath: "url(#peee9962114)",
  fill: "#b7ff40",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M583 380l5 10 5 26-6-10z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M452 600l1 4-9-19-1-5z",
  clipPath: "url(#peee9962114)",
  fill: "#0054ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M419 492l3 12-2-25-3-12z",
  clipPath: "url(#peee9962114)",
  fill: "#56ffa0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M667 499l27-6 3 8-28 6z",
  clipPath: "url(#peee9962114)",
  fill: "#3cffba",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M587 579l1 12-9 17-1-11z",
  clipPath: "url(#peee9962114)",
  fill: "#005cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M566 323l2 8 8 24-3-9z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M767 389l2-15-6 5-2 14z",
  clipPath: "url(#peee9962114)",
  fill: "#ffd000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M741 417l10-11-4 9-9 10z",
  clipPath: "url(#peee9962114)",
  fill: "#deff19",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M514 248l-7 8 14 7 5-7z",
  clipPath: "url(#peee9962114)",
  fill: "#890000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M787 483l20-10 1-10-20 11z",
  clipPath: "url(#peee9962114)",
  fill: "#6dff8a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M799 392l2-16-6-4-2 16z",
  clipPath: "url(#peee9962114)",
  fill: "#fc0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M718 442l16-9-2 10-16 7z",
  clipPath: "url(#peee9962114)",
  fill: "#adff49",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M754 515l26-8 3-7-26 8z",
  clipPath: "url(#peee9962114)",
  fill: "#2cffca",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M692 466l23-6-1 9-22 6z",
  clipPath: "url(#peee9962114)",
  fill: "#7dff7a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M655 543l32-8-5-4-32 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00dcfe",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M650 538l32-7-4-6-32 8z",
  clipPath: "url(#peee9962114)",
  fill: "#02e8f4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M774 386l2-15-7 3-2 15z",
  clipPath: "url(#peee9962114)",
  fill: "#ffc400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M556 641l-2 5-13 6 2-4z",
  clipPath: "url(#peee9962114)",
  fill: "#0000ed",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M711 537l30-7 5-4-31 8z",
  clipPath: "url(#peee9962114)",
  fill: "#02e8f4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M661 546l32-8-6-3-32 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00d4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M528 655l-2 2-13-1 2-2z",
  clipPath: "url(#peee9962114)",
  fill: "#0000d1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M793 388l2-16-6-2-3 15z",
  clipPath: "url(#peee9962114)",
  fill: "#ffc400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M665 490l27-6 2 9-27 6z",
  clipPath: "url(#peee9962114)",
  fill: "#53ffa4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M646 533l32-8-4-6-32 7z",
  clipPath: "url(#peee9962114)",
  fill: "#0ff8e7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M780 385l2-16-6 2-2 15z",
  clipPath: "url(#peee9962114)",
  fill: "#ffc100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M804 435l12-14-3-9-12 14z",
  clipPath: "url(#peee9962114)",
  fill: "#ceff29",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M786 385l3-15-7-1-2 16z",
  clipPath: "url(#peee9962114)",
  fill: "#ffbd00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M666 547l32-8-5-1-32 8z",
  clipPath: "url(#peee9962114)",
  fill: "#00d4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M746 411l10-12-5 7-10 11z",
  clipPath: "url(#peee9962114)",
  fill: "#f1fc06",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M558 301v8l10 22-2-8z",
  clipPath: "url(#peee9962114)",
  fill: "#ff2d00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M642 526l32-7-4-8-32 8z",
  clipPath: "url(#peee9962114)",
  fill: "#1cffdb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M424 330l2 14 10-17-2-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ff4e00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M593 416l3 13 3 27-4-13z",
  clipPath: "url(#peee9962114)",
  fill: "#c4ff33",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 256l-5 7 13 12 3-8z",
  clipPath: "url(#peee9962114)",
  fill: "#9b0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M413 427l4 15 3-24-4-15z",
  clipPath: "url(#peee9962114)",
  fill: "#d4ff23",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M443 581l1 4-7-20-2-6z",
  clipPath: "url(#peee9962114)",
  fill: "#008cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M788 474l20-11v-9l-20 10z",
  clipPath: "url(#peee9962114)",
  fill: "#87ff70",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671 547l32-7-5-1-32 8z",
  clipPath: "url(#peee9962114)",
  fill: "#00d4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M480 254l-6 12 15-2 5-11z",
  clipPath: "url(#peee9962114)",
  fill: "#8d0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721 434l17-9-4 8-16 9z",
  clipPath: "url(#peee9962114)",
  fill: "#c4ff33",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M757 508l26-8 3-8-26 9z",
  clipPath: "url(#peee9962114)",
  fill: "#43ffb4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M715 534l31-8 4-5-30 8z",
  clipPath: "url(#peee9962114)",
  fill: "#0ff8e7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M579 608l-1 9-10 13v-8z",
  clipPath: "url(#peee9962114)",
  fill: "#0028ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M598 522l1 13-5 23-1-13z",
  clipPath: "url(#peee9962114)",
  fill: "#02e8f4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M693 458l23-8-1 10-23 6z",
  clipPath: "url(#peee9962114)",
  fill: "#94ff63",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426 528l3 9-4-23-3-10z",
  clipPath: "url(#peee9962114)",
  fill: "#1cffdb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M487 644l-1-1-12-10h1z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M664 481l28-6v9l-27 6z",
  clipPath: "url(#peee9962114)",
  fill: "#66ff90",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475 633h-1l-11-13z",
  clipPath: "url(#peee9962114)",
  fill: "#0010ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M638 519l32-8-2-8-33 7z",
  clipPath: "url(#peee9962114)",
  fill: "#30ffc7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M801 426l12-14-4-8-12 14z",
  clipPath: "url(#peee9962114)",
  fill: "#e4ff13",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M548 283l-2 7 12 19v-8z",
  clipPath: "url(#peee9962114)",
  fill: "#e80000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M537 267l-3 8 12 15 2-7z",
  clipPath: "url(#peee9962114)",
  fill: "#b00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M448 283l-3 14 14-11 1-14z",
  clipPath: "url(#peee9962114)",
  fill: "#d10000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M751 405l10-12-5 6-10 12z",
  clipPath: "url(#peee9962114)",
  fill: "#feed00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M500 652l-2-2-12-7 1 1z",
  clipPath: "url(#peee9962114)",
  fill: "#0000f1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M576 355l5 9 7 26-5-10z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9f00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M677 546l31-8-5 2-32 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00d8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M463 620l-9-15-1-1z",
  clipPath: "url(#peee9962114)",
  fill: "#0038ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M541 652l-3 2-12 3 2-2z",
  clipPath: "url(#peee9962114)",
  fill: "#0000e3",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M788 464l20-10-2-10-19 11z",
  clipPath: "url(#peee9962114)",
  fill: "#9dff5a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M635 510l33-7-2-8-33 7z",
  clipPath: "url(#peee9962114)",
  fill: "#43ffb4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M797 418l12-14-5-7-11 14z",
  clipPath: "url(#peee9962114)",
  fill: "#f4f802",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720 529l30-8 4-6-31 9z",
  clipPath: "url(#peee9962114)",
  fill: "#1fffd7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M724 427l17-10-3 8-17 9z",
  clipPath: "url(#peee9962114)",
  fill: "#d7ff1f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M623 551l32-8-5-5-33 8z",
  clipPath: "url(#peee9962114)",
  fill: "#00d8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M760 501l26-9 1-9-26 9z",
  clipPath: "url(#peee9962114)",
  fill: "#56ffa0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617 546l33-8-4-5-33 8z",
  clipPath: "url(#peee9962114)",
  fill: "#00e4f8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M757 402l10-13-6 4-10 12z",
  clipPath: "url(#peee9962114)",
  fill: "#ffde00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M664 472l28-6v9l-28 6z",
  clipPath: "url(#peee9962114)",
  fill: "#7dff7a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M695 449l23-7-2 8-23 8z",
  clipPath: "url(#peee9962114)",
  fill: "#aaff4d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M513 656l-3-2-12-4 2 2z",
  clipPath: "url(#peee9962114)",
  fill: "#0000e8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M628 554l33-8-6-4-32 9z",
  clipPath: "url(#peee9962114)",
  fill: "#00d0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M417 467l3 12 1-24-4-13z",
  clipPath: "url(#peee9962114)",
  fill: "#94ff63",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M613 541l33-8-4-7-34 8z",
  clipPath: "url(#peee9962114)",
  fill: "#0cf4eb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M682 544l31-8-5 2-31 8z",
  clipPath: "url(#peee9962114)",
  fill: "#00e4f8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M599 456l1 14v27l-1-15z",
  clipPath: "url(#peee9962114)",
  fill: "#83ff73",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M418 365l3 15 8-20-3-16z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M568 630l-3 6-11 10 2-5z",
  clipPath: "url(#peee9962114)",
  fill: "#0008ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M793 411l11-14-5-5-12 14z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M634 556l32-9-5-1-33 8z",
  clipPath: "url(#peee9962114)",
  fill: "#0cf",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M594 558l1 12-7 21-1-12z",
  clipPath: "url(#peee9962114)",
  fill: "#00a0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M435 559l2 6-6-21-2-7z",
  clipPath: "url(#peee9962114)",
  fill: "#0cf",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M763 399l11-13-7 3-10 13z",
  clipPath: "url(#peee9962114)",
  fill: "#ffd300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M453 604l1 1-9-17-1-3z",
  clipPath: "url(#peee9962114)",
  fill: "#0064ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M608 534l34-8-4-7-33 7z",
  clipPath: "url(#peee9962114)",
  fill: "#1cffdb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M633 502l33-7-1-9-33 7z",
  clipPath: "url(#peee9962114)",
  fill: "#5aff9d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M494 253l-5 11 15 3 3-11z",
  clipPath: "url(#peee9962114)",
  fill: "maroon",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M787 455l19-11-2-9-19 11z",
  clipPath: "url(#peee9962114)",
  fill: "#b4ff43",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M787 406l12-14-6-4-11 14z",
  clipPath: "url(#peee9962114)",
  fill: "#ffdb00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M729 421l17-10-5 6-17 10z",
  clipPath: "url(#peee9962114)",
  fill: "#e7ff0f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769 399l11-14-6 1-11 13z",
  clipPath: "url(#peee9962114)",
  fill: "#ffd000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M639 556l32-9h-5l-32 9z",
  clipPath: "url(#peee9962114)",
  fill: "#00d0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M723 524l31-9 3-7-31 9z",
  clipPath: "url(#peee9962114)",
  fill: "#30ffc7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M782 402l11-14-7-3-10 15z",
  clipPath: "url(#peee9962114)",
  fill: "#ffd000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M776 400l10-15h-6l-11 14z",
  clipPath: "url(#peee9962114)",
  fill: "#fc0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M761 492l26-9 1-9-26 9z",
  clipPath: "url(#peee9962114)",
  fill: "#6dff8a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M665 464l28-6-1 8-28 6z",
  clipPath: "url(#peee9962114)",
  fill: "#94ff63",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M698 442l23-8-3 8-23 7z",
  clipPath: "url(#peee9962114)",
  fill: "#c1ff36",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M686 540l32-8-5 4-31 8z",
  clipPath: "url(#peee9962114)",
  fill: "#0cf4eb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M605 526l33-7-3-9-33 8z",
  clipPath: "url(#peee9962114)",
  fill: "#2cffca",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M568 331l4 9 9 24-5-9z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M588 390l3 12 5 27-3-13z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 657l-4-2-12-1 3 2z",
  clipPath: "url(#peee9962114)",
  fill: "#0000ed",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M422 504l3 10-1-24-4-11z",
  clipPath: "url(#peee9962114)",
  fill: "#56ffa0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M632 493l33-7-1-9-32 7z",
  clipPath: "url(#peee9962114)",
  fill: "#6dff8a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M645 555l32-9-6 1-32 9z",
  clipPath: "url(#peee9962114)",
  fill: "#00d4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434 312l2 15 11-15-2-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ff1a00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M785 446l19-11-3-9-19 12z",
  clipPath: "url(#peee9962114)",
  fill: "#caff2c",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486 643l-2-4-10-9v3z",
  clipPath: "url(#peee9962114)",
  fill: "#000cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M554 646l-4 2-12 6 3-2z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591 560l32-9-6-5-32 10z",
  clipPath: "url(#peee9962114)",
  fill: "#00d0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M585 556l32-10-4-5-33 8z",
  clipPath: "url(#peee9962114)",
  fill: "#00dcfe",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M474 633v-3l-11-12v2z",
  clipPath: "url(#peee9962114)",
  fill: "#0028ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734 416l17-11-5 6-17 10z",
  clipPath: "url(#peee9962114)",
  fill: "#f8f500",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460 272l-1 14 14-6 1-14z",
  clipPath: "url(#peee9962114)",
  fill: "#a40000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M597 564l31-10-5-3-32 9z",
  clipPath: "url(#peee9962114)",
  fill: "#00c8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M588 591l-1 9-9 17 1-9z",
  clipPath: "url(#peee9962114)",
  fill: "#0064ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M416 403l4 15 5-22-4-16z",
  clipPath: "url(#peee9962114)",
  fill: "gold",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M444 585l1 3-7-19-1-4z",
  clipPath: "url(#peee9962114)",
  fill: "#0098ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M602 518l33-8-2-8-33 7z",
  clipPath: "url(#peee9962114)",
  fill: "#43ffb4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M580 549l33-8-5-7-32 8z",
  clipPath: "url(#peee9962114)",
  fill: "#06ecf1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M498 650l-2-4-12-7 2 4z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M726 517l31-9 3-7-31 8z",
  clipPath: "url(#peee9962114)",
  fill: "#43ffb4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M762 483l26-9v-10l-26 10z",
  clipPath: "url(#peee9962114)",
  fill: "#83ff73",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M507 256l-3 11 15 7 2-11z",
  clipPath: "url(#peee9962114)",
  fill: "#840000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M690 534l32-7-4 5-32 8z",
  clipPath: "url(#peee9962114)",
  fill: "#19ffde",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M600 497l2 14-3 24-1-13z",
  clipPath: "url(#peee9962114)",
  fill: "#40ffb7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M602 566l32-10-6-2-31 10z",
  clipPath: "url(#peee9962114)",
  fill: "#00c4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M701 435l23-8-3 7-23 8z",
  clipPath: "url(#peee9962114)",
  fill: "#d4ff23",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M667 456l28-7-2 9-28 6z",
  clipPath: "url(#peee9962114)",
  fill: "#aaff4d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M463 620v-2l-9-15v2z",
  clipPath: "url(#peee9962114)",
  fill: "#004cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M650 552l32-8-5 2-32 9z",
  clipPath: "url(#peee9962114)",
  fill: "#00e0fb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M576 542l32-8-3-8-33 8z",
  clipPath: "url(#peee9962114)",
  fill: "#16ffe1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M782 438l19-12-4-8-19 12z",
  clipPath: "url(#peee9962114)",
  fill: "#deff19",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M558 309l3 10 11 21-4-9z",
  clipPath: "url(#peee9962114)",
  fill: "#ff2900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M739 413l18-11-6 3-17 11z",
  clipPath: "url(#peee9962114)",
  fill: "#ffea00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M632 484l32-7 1-9-33 7z",
  clipPath: "url(#peee9962114)",
  fill: "#83ff73",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M429 537l2 7-3-22-3-8z",
  clipPath: "url(#peee9962114)",
  fill: "#1fffd7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M510 654l-3-4-11-4 2 4z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M608 566l31-10h-5l-32 10z",
  clipPath: "url(#peee9962114)",
  fill: "#00c4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M600 509l33-7-1-9-34 6z",
  clipPath: "url(#peee9962114)",
  fill: "#56ffa0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M538 654l-4-2-12 3 4 2z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M572 534l33-8-3-8-33 7z",
  clipPath: "url(#peee9962114)",
  fill: "#29ffce",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M778 430l19-12-4-7-19 13z",
  clipPath: "url(#peee9962114)",
  fill: "#eeff09",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M521 263l-2 11 15 11v-10z",
  clipPath: "url(#peee9962114)",
  fill: "#920000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578 617l-3 6-10 13 3-6z",
  clipPath: "url(#peee9962114)",
  fill: "#0038ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M745 411l18-12-6 3-18 11z",
  clipPath: "url(#peee9962114)",
  fill: "#ffde00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M762 474l26-10-1-9-26 10z",
  clipPath: "url(#peee9962114)",
  fill: "#9aff5d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M454 605v-2l-8-16-1 1z",
  clipPath: "url(#peee9962114)",
  fill: "#0074ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M729 509l31-8 1-9-31 9z",
  clipPath: "url(#peee9962114)",
  fill: "#5aff9d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M562 570l29-10-6-4-29 9z",
  clipPath: "url(#peee9962114)",
  fill: "#00c4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M556 565l29-9-5-7-30 10z",
  clipPath: "url(#peee9962114)",
  fill: "#00d0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M417 442l4 13 3-23-4-14z",
  clipPath: "url(#peee9962114)",
  fill: "#d1ff26",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M705 430l24-9-5 6-23 8z",
  clipPath: "url(#peee9962114)",
  fill: "#e4ff13",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M546 290l2 10 13 19-3-10z",
  clipPath: "url(#peee9962114)",
  fill: "#df0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M693 528l32-8-3 7-32 7z",
  clipPath: "url(#peee9962114)",
  fill: "#29ffce",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M596 429l2 14 2 27-1-14z",
  clipPath: "url(#peee9962114)",
  fill: "#c4ff33",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M568 574l29-10-6-4-29 10z",
  clipPath: "url(#peee9962114)",
  fill: "#00bcff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M654 548l32-8-4 4-32 8z",
  clipPath: "url(#peee9962114)",
  fill: "#09f0ee",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M670 449l28-7-3 7-28 7z",
  clipPath: "url(#peee9962114)",
  fill: "#beff39",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M534 275v10l14 15-2-10z",
  clipPath: "url(#peee9962114)",
  fill: "#b20000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M614 564l31-9-6 1-31 10z",
  clipPath: "url(#peee9962114)",
  fill: "#0cf",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M550 559l30-10-4-7-31 9z",
  clipPath: "url(#peee9962114)",
  fill: "#00e0fb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M774 424l19-13-6-5-19 13z",
  clipPath: "url(#peee9962114)",
  fill: "#fbf100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426 344l3 16 10-17-3-16z",
  clipPath: "url(#peee9962114)",
  fill: "#ff5200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M751 411l18-12h-6l-18 12z",
  clipPath: "url(#peee9962114)",
  fill: "#ffdb00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M581 364l3 12 7 26-3-12z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9f00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M437 565l1 4-5-21-2-4z",
  clipPath: "url(#peee9962114)",
  fill: "#00d4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M484 639v-6l-10-9v6z",
  clipPath: "url(#peee9962114)",
  fill: "#0028ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M574 576l28-10-5-2-29 10z",
  clipPath: "url(#peee9962114)",
  fill: "#00b8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M632 475l33-7 1-8-32 6z",
  clipPath: "url(#peee9962114)",
  fill: "#9aff5d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M599 535l1 13-5 22-1-12z",
  clipPath: "url(#peee9962114)",
  fill: "#02e8f4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M474 630v-6l-9-11-2 5z",
  clipPath: "url(#peee9962114)",
  fill: "#0040ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M598 499l34-6v-9l-34 6z",
  clipPath: "url(#peee9962114)",
  fill: "#6dff8a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M569 525l33-7-2-9-34 6z",
  clipPath: "url(#peee9962114)",
  fill: "#40ffb7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M768 419l19-13-5-4-19 13z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M757 412l19-12-7-1-18 12z",
  clipPath: "url(#peee9962114)",
  fill: "gold",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M522 655l-3-5h-12l3 4z",
  clipPath: "url(#peee9962114)",
  fill: "#00f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M763 415l19-13-6-2-19 12z",
  clipPath: "url(#peee9962114)",
  fill: "#ffdb00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M545 551l31-9-4-8-31 8z",
  clipPath: "url(#peee9962114)",
  fill: "#0ff8e7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M496 646l-1-7-11-6v6z",
  clipPath: "url(#peee9962114)",
  fill: "#0018ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M474 266l-1 14 15-2 1-14z",
  clipPath: "url(#peee9962114)",
  fill: "#890000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565 636l-4 2-11 10 4-2z",
  clipPath: "url(#peee9962114)",
  fill: "#0018ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M761 465l26-10-2-9-26 11z",
  clipPath: "url(#peee9962114)",
  fill: "#b1ff46",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M710 425l24-9-5 5-24 9z",
  clipPath: "url(#peee9962114)",
  fill: "#f1fc06",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M463 618l2-5-9-13-2 3z",
  clipPath: "url(#peee9962114)",
  fill: "#0060ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M730 501l31-9 1-9-31 9z",
  clipPath: "url(#peee9962114)",
  fill: "#6dff8a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M581 576l27-10h-6l-28 10z",
  clipPath: "url(#peee9962114)",
  fill: "#00b8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M420 479l4 11v-23l-3-12z",
  clipPath: "url(#peee9962114)",
  fill: "#94ff63",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M619 562l31-10-5 3-31 9z",
  clipPath: "url(#peee9962114)",
  fill: "#00d8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M537 581l25-11-6-5-26 11z",
  clipPath: "url(#peee9962114)",
  fill: "#00b4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M696 521l32-8-3 7-32 8z",
  clipPath: "url(#peee9962114)",
  fill: "#3cffba",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M658 543l32-9-4 6-32 8z",
  clipPath: "url(#peee9962114)",
  fill: "#16ffe1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M530 576l26-11-6-6-26 9z",
  clipPath: "url(#peee9962114)",
  fill: "#00c0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M445 588l1-1-6-18h-2z",
  clipPath: "url(#peee9962114)",
  fill: "#00a8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M673 442l28-7-3 7-28 7z",
  clipPath: "url(#peee9962114)",
  fill: "#d1ff26",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M445 297l2 15 13-10-1-16z",
  clipPath: "url(#peee9962114)",
  fill: "#d10000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M543 585l25-11-6-4-25 11z",
  clipPath: "url(#peee9962114)",
  fill: "#00a8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M541 542l31-8-3-9-31 7z",
  clipPath: "url(#peee9962114)",
  fill: "#23ffd4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M507 650l-2-7-10-4 1 7z",
  clipPath: "url(#peee9962114)",
  fill: "#0010ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524 568l26-9-5-8-26 9z",
  clipPath: "url(#peee9962114)",
  fill: "#00d4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M566 515l34-6-2-10-33 6z",
  clipPath: "url(#peee9962114)",
  fill: "#56ffa0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M550 648l-5-2-11 6 4 2z",
  clipPath: "url(#peee9962114)",
  fill: "#0008ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M598 490l34-6v-9l-34 6z",
  clipPath: "url(#peee9962114)",
  fill: "#83ff73",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M634 466l32-6 2-8-32 7z",
  clipPath: "url(#peee9962114)",
  fill: "#b1ff46",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M759 457l26-11-3-8-26 11z",
  clipPath: "url(#peee9962114)",
  fill: "#c4ff33",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M550 587l24-11-6-2-25 11z",
  clipPath: "url(#peee9962114)",
  fill: "#00a8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M715 422l24-9-5 3-24 9z",
  clipPath: "url(#peee9962114)",
  fill: "#feed00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M595 570l-1 10-7 20 1-9z",
  clipPath: "url(#peee9962114)",
  fill: "#00a8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M587 575l27-11-6 2-27 10z",
  clipPath: "url(#peee9962114)",
  fill: "#00c0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M484 633l2-8-9-9-3 8z",
  clipPath: "url(#peee9962114)",
  fill: "#0040ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M454 603l2-3-7-16-3 3z",
  clipPath: "url(#peee9962114)",
  fill: "#08f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M425 514l3 8-2-23-2-9z",
  clipPath: "url(#peee9962114)",
  fill: "#5aff9d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M474 624l3-8-9-10-3 7z",
  clipPath: "url(#peee9962114)",
  fill: "#0058ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M422 380l3 16 8-20-4-16z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M519 560l26-9-4-9-27 8z",
  clipPath: "url(#peee9962114)",
  fill: "#06ecf1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M517 593l20-12-7-5-21 10z",
  clipPath: "url(#peee9962114)",
  fill: "#00a0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M624 557l30-9-4 4-31 10z",
  clipPath: "url(#peee9962114)",
  fill: "#02e8f4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M509 586l21-10-6-8-21 10z",
  clipPath: "url(#peee9962114)",
  fill: "#00b0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M600 470l2 15v26l-2-14z",
  clipPath: "url(#peee9962114)",
  fill: "#83ff73",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M495 639l1-9-10-5-2 8z",
  clipPath: "url(#peee9962114)",
  fill: "#0034ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M731 492l31-9v-9l-31 9z",
  clipPath: "url(#peee9962114)",
  fill: "#83ff73",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M534 652l-4-4-11 2 3 5z",
  clipPath: "url(#peee9962114)",
  fill: "#0008ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M538 532l31-7-3-10-31 7z",
  clipPath: "url(#peee9962114)",
  fill: "#39ffbe",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M572 340l2 13 10 23-3-12z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524 597l19-12-6-4-20 12z",
  clipPath: "url(#peee9962114)",
  fill: "#0094ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M677 437l28-7-4 5-28 7z",
  clipPath: "url(#peee9962114)",
  fill: "#e1ff16",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M662 536l31-8-3 6-32 9z",
  clipPath: "url(#peee9962114)",
  fill: "#29ffce",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M698 513l32-8-2 8-32 8z",
  clipPath: "url(#peee9962114)",
  fill: "#53ffa4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M465 613l3-7-8-12-4 6z",
  clipPath: "url(#peee9962114)",
  fill: "#0074ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M557 588l24-12h-7l-24 11z",
  clipPath: "url(#peee9962114)",
  fill: "#00a8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M756 449l26-11-4-8-26 11z",
  clipPath: "url(#peee9962114)",
  fill: "#d7ff1f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M503 578l21-10-5-8-22 9z",
  clipPath: "url(#peee9962114)",
  fill: "#00c4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721 421l24-10-6 2-24 9z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M431 544l2 4-4-21-1-5z",
  clipPath: "url(#peee9962114)",
  fill: "#26ffd1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M519 650l-3-7h-11l2 7z",
  clipPath: "url(#peee9962114)",
  fill: "#0014ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565 505l33-6v-9l-34 5z",
  clipPath: "url(#peee9962114)",
  fill: "#6dff8a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M489 264l-1 14 16 2v-13z",
  clipPath: "url(#peee9962114)",
  fill: "maroon",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486 625l6-10-9-8-6 9z",
  clipPath: "url(#peee9962114)",
  fill: "#005cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M502 604l15-11-8-7-15 11z",
  clipPath: "url(#peee9962114)",
  fill: "#008cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M477 616l6-9-8-9-7 8z",
  clipPath: "url(#peee9962114)",
  fill: "#0070ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M514 550l27-8-3-10-28 8z",
  clipPath: "url(#peee9962114)",
  fill: "#1cffdb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M494 597l15-11-6-8-16 10z",
  clipPath: "url(#peee9962114)",
  fill: "#009cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M531 599l19-12-7-2-19 12z",
  clipPath: "url(#peee9962114)",
  fill: "#0094ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M505 643l1-10-10-3-1 9z",
  clipPath: "url(#peee9962114)",
  fill: "#002cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591 402l2 15 5 26-2-14z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M592 572l27-10-5 2-27 11z",
  clipPath: "url(#peee9962114)",
  fill: "#0cf",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M587 600l-3 6-9 17 3-6z",
  clipPath: "url(#peee9962114)",
  fill: "#0070ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M598 481l34-6 2-9-34 6z",
  clipPath: "url(#peee9962114)",
  fill: "#9aff5d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M636 459l32-7 3-7-32 7z",
  clipPath: "url(#peee9962114)",
  fill: "#c4ff33",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M492 615l10-11-8-7-11 10z",
  clipPath: "url(#peee9962114)",
  fill: "#0074ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M510 609l14-12-7-4-15 11z",
  clipPath: "url(#peee9962114)",
  fill: "#0080ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M496 630l5-10-9-5-6 10z",
  clipPath: "url(#peee9962114)",
  fill: "#004cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M438 569h2l-5-19-2-2z",
  clipPath: "url(#peee9962114)",
  fill: "#00e0fb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M752 441l26-11-4-6-26 11z",
  clipPath: "url(#peee9962114)",
  fill: "#e7ff0f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M483 607l11-10-7-9-12 10z",
  clipPath: "url(#peee9962114)",
  fill: "#0084ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727 421l24-10h-6l-24 10z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M497 569l22-9-5-10-22 8z",
  clipPath: "url(#peee9962114)",
  fill: "#00e0fb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M487 588l16-10-6-9-17 9z",
  clipPath: "url(#peee9962114)",
  fill: "#00b4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M468 606l7-8-7-12-8 8z",
  clipPath: "url(#peee9962114)",
  fill: "#008cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M446 587l3-3-6-16-3 1z",
  clipPath: "url(#peee9962114)",
  fill: "#00b4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M501 620l9-11-8-5-10 11z",
  clipPath: "url(#peee9962114)",
  fill: "#0068ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M731 483l31-9-1-9-32 9z",
  clipPath: "url(#peee9962114)",
  fill: "#9aff5d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M456 600l4-6-6-14-5 4z",
  clipPath: "url(#peee9962114)",
  fill: "#009cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M629 551l29-8-4 5-30 9z",
  clipPath: "url(#peee9962114)",
  fill: "#13fce4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564 586l23-11-6 1-24 12z",
  clipPath: "url(#peee9962114)",
  fill: "#00b0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M420 418l4 14 5-21-4-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ffdb00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M535 522l31-7-1-10-32 6z",
  clipPath: "url(#peee9962114)",
  fill: "#53ffa4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M682 433l28-8-5 5-28 7z",
  clipPath: "url(#peee9962114)",
  fill: "#eeff09",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M748 435l26-11-6-5-25 10z",
  clipPath: "url(#peee9962114)",
  fill: "#f4f802",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475 598l12-10-7-10-12 8z",
  clipPath: "url(#peee9962114)",
  fill: "#00a0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M732 422l25-10-6-1-25 10z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M518 611l13-12-7-2-14 12z",
  clipPath: "url(#peee9962114)",
  fill: "#007cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539 600l18-12-7-1-19 12z",
  clipPath: "url(#peee9962114)",
  fill: "#0094ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M575 623l-4 2-10 13 4-2z",
  clipPath: "url(#peee9962114)",
  fill: "#04f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M436 327l3 16 11-15-3-16z",
  clipPath: "url(#peee9962114)",
  fill: "#ff1e00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M699 504l32-7-1 8-32 8z",
  clipPath: "url(#peee9962114)",
  fill: "#66ff90",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M506 633l4-10-9-3-5 10z",
  clipPath: "url(#peee9962114)",
  fill: "#0048ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M743 429l25-10-5-4-25 10z",
  clipPath: "url(#peee9962114)",
  fill: "#feed00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M665 528l31-7-3 7-31 8z",
  clipPath: "url(#peee9962114)",
  fill: "#3cffba",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M738 425l25-10-6-3-25 10z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M510 540l28-8-3-10-28 6z",
  clipPath: "url(#peee9962114)",
  fill: "#36ffc1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M510 623l8-12-8-2-9 11z",
  clipPath: "url(#peee9962114)",
  fill: "#0064ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M480 578l17-9-5-11-18 8z",
  clipPath: "url(#peee9962114)",
  fill: "#00d0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M561 319l2 12 11 22-2-13z",
  clipPath: "url(#peee9962114)",
  fill: "#ff2900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564 495l34-5v-9l-33 5z",
  clipPath: "url(#peee9962114)",
  fill: "#87ff70",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M516 643v-9l-10-1-1 10z",
  clipPath: "url(#peee9962114)",
  fill: "#0030ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M492 558l22-8-4-10-22 7z",
  clipPath: "url(#peee9962114)",
  fill: "#13fce4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M602 511v12l-2 25-1-13z",
  clipPath: "url(#peee9962114)",
  fill: "#43ffb4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460 594l8-8-6-12-8 6z",
  clipPath: "url(#peee9962114)",
  fill: "#00acff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M561 638l-5-1-11 9 5 2z",
  clipPath: "url(#peee9962114)",
  fill: "#002cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M459 286l1 16 15-7-2-15z",
  clipPath: "url(#peee9962114)",
  fill: "#a80000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M598 567l26-10-5 5-27 10z",
  clipPath: "url(#peee9962114)",
  fill: "#00dcfe",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M504 267v13l16 7-1-13z",
  clipPath: "url(#peee9962114)",
  fill: "maroon",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M530 648l-4-7-10 2 3 7z",
  clipPath: "url(#peee9962114)",
  fill: "#0020ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M639 452l32-7 4-6-32 7z",
  clipPath: "url(#peee9962114)",
  fill: "#d7ff1f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M468 586l12-8-6-12-12 8z",
  clipPath: "url(#peee9962114)",
  fill: "#00c0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M545 646l-5-4-10 6 4 4z",
  clipPath: "url(#peee9962114)",
  fill: "#0020ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M600 472l34-6 2-7-34 5zm129 2l32-9-2-8-31 9z",
  clipPath: "url(#peee9962114)",
  fill: "#b1ff46",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M421 455l3 12 3-22-3-13z",
  clipPath: "url(#peee9962114)",
  fill: "#ceff29",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 612l13-12-8-1-13 12z",
  clipPath: "url(#peee9962114)",
  fill: "#007cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M686 430l29-8-5 3-28 8z",
  clipPath: "url(#peee9962114)",
  fill: "#fbf100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M570 583l22-11-5 3-23 11z",
  clipPath: "url(#peee9962114)",
  fill: "#00bcff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M449 584l5-4-6-15-5 3z",
  clipPath: "url(#peee9962114)",
  fill: "#00c4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M546 598l18-12-7 2-18 12z",
  clipPath: "url(#peee9962114)",
  fill: "#009cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M533 511l32-6-1-10-31 5z",
  clipPath: "url(#peee9962114)",
  fill: "#6dff8a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M516 634l3-11h-9l-4 10z",
  clipPath: "url(#peee9962114)",
  fill: "#004cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M632 544l30-8-4 7-29 8z",
  clipPath: "url(#peee9962114)",
  fill: "#23ffd4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M519 623l7-11-8-1-8 12z",
  clipPath: "url(#peee9962114)",
  fill: "#0064ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M474 566l18-8-4-11-18 7z",
  clipPath: "url(#peee9962114)",
  fill: "#09f0ee",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M548 300l2 13 13 18-2-12z",
  clipPath: "url(#peee9962114)",
  fill: "#df0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M699 495l32-7v9l-32 7z",
  clipPath: "url(#peee9962114)",
  fill: "#7dff7a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M440 569l3-1-5-18h-3z",
  clipPath: "url(#peee9962114)",
  fill: "#02e8f4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M424 490l2 9v-22l-2-10z",
  clipPath: "url(#peee9962114)",
  fill: "#94ff63",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M519 274l1 13 15 11-1-13z",
  clipPath: "url(#peee9962114)",
  fill: "#920000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M667 520l31-7-2 8-31 7zm-159 8l27-6-2-11-27 6z",
  clipPath: "url(#peee9962114)",
  fill: "#50ffa7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M488 547l22-7-2-12-24 6z",
  clipPath: "url(#peee9962114)",
  fill: "#30ffc7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M728 466l31-9-3-8-31 9z",
  clipPath: "url(#peee9962114)",
  fill: "#c4ff33",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M433 548l2 2-3-19-3-4z",
  clipPath: "url(#peee9962114)",
  fill: "#2cffca",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M454 580l8-6-5-14-9 5z",
  clipPath: "url(#peee9962114)",
  fill: "#00d4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M428 522l1 5-1-21-2-7z",
  clipPath: "url(#peee9962114)",
  fill: "#5aff9d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M534 285l1 13 15 15-2-13z",
  clipPath: "url(#peee9962114)",
  fill: "#b20000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M462 574l12-8-4-12-13 6z",
  clipPath: "url(#peee9962114)",
  fill: "#00e4f8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M692 429l29-8-6 1-29 8z",
  clipPath: "url(#peee9962114)",
  fill: "#ffea00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565 486l33-5 2-9-34 4z",
  clipPath: "url(#peee9962114)",
  fill: "#9dff5a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643 446l32-7 4-4-32 6z",
  clipPath: "url(#peee9962114)",
  fill: "#e7ff0f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M602 561l27-10-5 6-26 10z",
  clipPath: "url(#peee9962114)",
  fill: "#09f0ee",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M600 548l-2 10-4 22 1-10z",
  clipPath: "url(#peee9962114)",
  fill: "#06ecf1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 641l-1-9-9 2v9z",
  clipPath: "url(#peee9962114)",
  fill: "#003cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M534 610l12-12-7 2-13 12z",
  clipPath: "url(#peee9962114)",
  fill: "#08f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M598 443l1 15 3 27-2-15z",
  clipPath: "url(#peee9962114)",
  fill: "#c4ff33",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M584 376l2 15 7 26-2-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9f00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M602 464l34-5 3-7-34 4z",
  clipPath: "url(#peee9962114)",
  fill: "#c7ff30",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M429 360l4 16 9-17-3-16z",
  clipPath: "url(#peee9962114)",
  fill: "#ff5900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M576 578l22-11-6 5-22 11z",
  clipPath: "url(#peee9962114)",
  fill: "#00d0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M725 458l31-9-4-8-31 9z",
  clipPath: "url(#peee9962114)",
  fill: "#d7ff1f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M553 594l17-11-6 3-18 12z",
  clipPath: "url(#peee9962114)",
  fill: "#00acff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M697 429l30-8h-6l-29 8z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M527 621l7-11-8 2-7 11z",
  clipPath: "url(#peee9962114)",
  fill: "#0070ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M525 632l2-11-8 2-3 11z",
  clipPath: "url(#peee9962114)",
  fill: "#0054ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M533 500l31-5 1-9-32 4z",
  clipPath: "url(#peee9962114)",
  fill: "#87ff70",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M698 486l32-7 1 9-32 7z",
  clipPath: "url(#peee9962114)",
  fill: "#94ff63",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M470 554l18-7-4-13-18 6z",
  clipPath: "url(#peee9962114)",
  fill: "#26ffd1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M635 536l30-8-3 8-30 8z",
  clipPath: "url(#peee9962114)",
  fill: "#39ffbe",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M540 642l-4-6-10 5 4 7z",
  clipPath: "url(#peee9962114)",
  fill: "#0038ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M443 568l5-3-4-17-6 2z",
  clipPath: "url(#peee9962114)",
  fill: "#0cf4eb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M668 511l31-7-1 9-31 7z",
  clipPath: "url(#peee9962114)",
  fill: "#66ff90",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M594 580l-4 7-6 19 3-6z",
  clipPath: "url(#peee9962114)",
  fill: "#00b0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721 450l31-9-4-6-31 8z",
  clipPath: "url(#peee9962114)",
  fill: "#e4ff13",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M506 517l27-6v-11l-28 5z",
  clipPath: "url(#peee9962114)",
  fill: "#6aff8d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M702 430l30-8-6-1-29 8z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M484 534l23-6-1-11-24 5z",
  clipPath: "url(#peee9962114)",
  fill: "#49ffad",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M647 441l32-6 5-4-32 6z",
  clipPath: "url(#peee9962114)",
  fill: "#f4f802",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473 280l2 15 15-2-2-15z",
  clipPath: "url(#peee9962114)",
  fill: "#8d0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M556 637l-6-3-10 8 5 4z",
  clipPath: "url(#peee9962114)",
  fill: "#0040ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M457 560l13-6-4-14-13 5z",
  clipPath: "url(#peee9962114)",
  fill: "#1fffd7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M448 565l9-5-4-15-9 3z",
  clipPath: "url(#peee9962114)",
  fill: "#16ffe1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M717 443l31-8-5-6-30 9z",
  clipPath: "url(#peee9962114)",
  fill: "#f1fc06",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M566 476l34-4 2-8-34 4z",
  clipPath: "url(#peee9962114)",
  fill: "#b4ff43",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M708 433l30-8-6-3-30 8z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M584 606l-6 4-7 15 4-2z",
  clipPath: "url(#peee9962114)",
  fill: "#007cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M713 438l30-9-5-4-30 8z",
  clipPath: "url(#peee9962114)",
  fill: "#feed00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M606 553l26-9-3 7-27 10z",
  clipPath: "url(#peee9962114)",
  fill: "#1cffdb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M571 625h-6l-9 12 5 1z",
  clipPath: "url(#peee9962114)",
  fill: "#0054ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447 312l3 16 13-10-3-16z",
  clipPath: "url(#peee9962114)",
  fill: "#d60000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M542 606l11-12-7 4-12 12z",
  clipPath: "url(#peee9962114)",
  fill: "#0098ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M605 456l34-4 4-6-34 4z",
  clipPath: "url(#peee9962114)",
  fill: "#d7ff1f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M425 396l4 15 7-20-3-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9c00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M435 550h3l-3-18-3-1z",
  clipPath: "url(#peee9962114)",
  fill: "#30ffc7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M697 477l32-7 1 9-32 7z",
  clipPath: "url(#peee9962114)",
  fill: "#aaff4d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M536 636l-2-9-9 5 1 9z",
  clipPath: "url(#peee9962114)",
  fill: "#0050ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M581 571l21-10-4 6-22 11z",
  clipPath: "url(#peee9962114)",
  fill: "#00e4f8",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M559 589l17-11-6 5-17 11z",
  clipPath: "url(#peee9962114)",
  fill: "#00c0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M652 437l32-6 5-2-32 6z",
  clipPath: "url(#peee9962114)",
  fill: "#feed00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M533 490l32-4 1-10-31 4z",
  clipPath: "url(#peee9962114)",
  fill: "#a0ff56",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M637 527l30-7-2 8-30 8z",
  clipPath: "url(#peee9962114)",
  fill: "#50ffa7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M536 617l6-11-8 4-7 11z",
  clipPath: "url(#peee9962114)",
  fill: "#0080ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M466 540l18-6-2-12-18 4z",
  clipPath: "url(#peee9962114)",
  fill: "#46ffb1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M602 485v38-12z",
  clipPath: "url(#peee9962114)",
  fill: "#83ff73",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M668 502l31-7v9l-31 7z",
  clipPath: "url(#peee9962114)",
  fill: "#7dff7a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M534 627l2-10-9 4-2 11z",
  clipPath: "url(#peee9962114)",
  fill: "#0068ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M429 527l3 4-2-20-2-5z",
  clipPath: "url(#peee9962114)",
  fill: "#5dff9a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M574 353l2 15 10 23-2-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M424 432l3 13 5-21-3-13z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M505 505l28-5v-10l-28 3z",
  clipPath: "url(#peee9962114)",
  fill: "#87ff70",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M482 522l24-5-1-12-23 4z",
  clipPath: "url(#peee9962114)",
  fill: "#6aff8d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M694 468l32-6 3 8-32 7z",
  clipPath: "url(#peee9962114)",
  fill: "#beff39",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M438 550l6-2-3-16h-6z",
  clipPath: "url(#peee9962114)",
  fill: "#36ffc1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M568 468l34-4 3-8-33 4z",
  clipPath: "url(#peee9962114)",
  fill: "#caff2c",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M609 450l34-4 4-5-34 4z",
  clipPath: "url(#peee9962114)",
  fill: "#e7ff0f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426 499l2 7v-20l-2-9z",
  clipPath: "url(#peee9962114)",
  fill: "#90ff66",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M424 467l2 10 3-21-2-11z",
  clipPath: "url(#peee9962114)",
  fill: "#caff2c",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M453 545l13-5-2-14-14 3z",
  clipPath: "url(#peee9962114)",
  fill: "#40ffb7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M657 435l32-6h5l-32 6z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M550 634l-5-6-9 8 4 6z",
  clipPath: "url(#peee9962114)",
  fill: "#0054ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M609 545l26-9-3 8-26 9z",
  clipPath: "url(#peee9962114)",
  fill: "#33ffc4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M444 548l9-3-3-16-9 3z",
  clipPath: "url(#peee9962114)",
  fill: "#3cffba",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M548 600l11-11-6 5-11 12z",
  clipPath: "url(#peee9962114)",
  fill: "#00acff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M488 278l2 15 16 2-2-15z",
  clipPath: "url(#peee9962114)",
  fill: "maroon",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M593 417l2 15 4 26-1-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ffea00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M691 460l32-6 3 8-32 6z",
  clipPath: "url(#peee9962114)",
  fill: "#d1ff26",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M667 492l31-6 1 9-31 7z",
  clipPath: "url(#peee9962114)",
  fill: "#94ff63",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M585 563l21-10-4 8-21 10z",
  clipPath: "url(#peee9962114)",
  fill: "#16ffe1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565 581l16-10-5 7-17 11z",
  clipPath: "url(#peee9962114)",
  fill: "#00d8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M638 518l30-7-1 9-30 7z",
  clipPath: "url(#peee9962114)",
  fill: "#66ff90",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M662 435l32-6h6l-33 7z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M535 480l31-4 2-8-31 2z",
  clipPath: "url(#peee9962114)",
  fill: "#b7ff40",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M602 523l-1 12-3 23 2-10z",
  clipPath: "url(#peee9962114)",
  fill: "#43ffb4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M439 343l3 16 12-14-4-17z",
  clipPath: "url(#peee9962114)",
  fill: "#ff2500",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M464 526l18-4v-13l-19 3z",
  clipPath: "url(#peee9962114)",
  fill: "#66ff90",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M543 610l5-10-6 6-6 11z",
  clipPath: "url(#peee9962114)",
  fill: "#0098ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565 625l-7-2-8 11 6 3z",
  clipPath: "url(#peee9962114)",
  fill: "#0068ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M687 453l32-6 4 7-32 6z",
  clipPath: "url(#peee9962114)",
  fill: "#e1ff16",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M613 445l34-4 5-4-34 5z",
  clipPath: "url(#peee9962114)",
  fill: "#f8f500",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M545 628l-3-8-8 7 2 9z",
  clipPath: "url(#peee9962114)",
  fill: "#006cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M563 331l2 15 11 22-2-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ff2900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M432 531l3 1-1-18-4-3z",
  clipPath: "url(#peee9962114)",
  fill: "#60ff97",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M667 436l33-7 5 3-32 6z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M572 460l33-4 4-6-33 3z",
  clipPath: "url(#peee9962114)",
  fill: "#deff19",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M505 493l28-3 2-10-28 2z",
  clipPath: "url(#peee9962114)",
  fill: "#a4ff53",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M542 620l1-10-7 7-2 10z",
  clipPath: "url(#peee9962114)",
  fill: "#0080ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M482 509l23-4v-12l-23 3z",
  clipPath: "url(#peee9962114)",
  fill: "#87ff70",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M683 447l32-7 4 7-32 6z",
  clipPath: "url(#peee9962114)",
  fill: "#eeff09",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M673 438l32-6 5 3-32 7z",
  clipPath: "url(#peee9962114)",
  fill: "#ffea00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460 302l3 16 15-6-3-17z",
  clipPath: "url(#peee9962114)",
  fill: "#ad0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M678 442l32-7 5 5-32 7z",
  clipPath: "url(#peee9962114)",
  fill: "#fbf100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M598 558l-3 8-5 21 4-7z",
  clipPath: "url(#peee9962114)",
  fill: "#0cf4eb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M665 483l32-6 1 9-31 6z",
  clipPath: "url(#peee9962114)",
  fill: "#aaff4d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M611 535l26-8-2 9-26 9z",
  clipPath: "url(#peee9962114)",
  fill: "#4dffaa",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578 610l-6 1-7 14h6z",
  clipPath: "url(#peee9962114)",
  fill: "#08f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M504 280l2 15 16 7-2-15z",
  clipPath: "url(#peee9962114)",
  fill: "maroon",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M450 529l14-3-1-14-14 2z",
  clipPath: "url(#peee9962114)",
  fill: "#66ff90",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M590 587l-5 5-7 18 6-4z",
  clipPath: "url(#peee9962114)",
  fill: "#00b8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M554 592l11-11-6 8-11 11z",
  clipPath: "url(#peee9962114)",
  fill: "#00c8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M638 508l30-6v9l-30 7z",
  clipPath: "url(#peee9962114)",
  fill: "#7dff7a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M435 532h6l-1-17-6-1z",
  clipPath: "url(#peee9962114)",
  fill: "#60ff97",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M618 442l34-5 5-2-34 5z",
  clipPath: "url(#peee9962114)",
  fill: "#ffea00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M550 313l1 15 14 18-2-15z",
  clipPath: "url(#peee9962114)",
  fill: "#df0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M441 532l9-3-1-15-9 1z",
  clipPath: "url(#peee9962114)",
  fill: "#63ff94",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M428 506l2 5 1-19-3-6z",
  clipPath: "url(#peee9962114)",
  fill: "#90ff66",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M588 553l21-8-3 8-21 10z",
  clipPath: "url(#peee9962114)",
  fill: "#2cffca",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M537 471l31-3 4-8-31 2z",
  clipPath: "url(#peee9962114)",
  fill: "#d1ff26",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M433 376l3 15 9-16-3-16z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M569 572l16-9-4 8-16 10z",
  clipPath: "url(#peee9962114)",
  fill: "#0cf4eb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M520 287l2 15 15 11-2-15z",
  clipPath: "url(#peee9962114)",
  fill: "#920000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M576 453l33-3 4-5-33 3z",
  clipPath: "url(#peee9962114)",
  fill: "#eeff09",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M663 474l31-6 3 9-32 6z",
  clipPath: "url(#peee9962114)",
  fill: "#c1ff36",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M558 623l-5-6-8 11 5 6z",
  clipPath: "url(#peee9962114)",
  fill: "#007cff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M535 298l2 15 14 15-1-15z",
  clipPath: "url(#peee9962114)",
  fill: "#b20000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M599 458l1 14 2 26v-13z",
  clipPath: "url(#peee9962114)",
  fill: "#c1ff36",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M463 512l19-3v-13l-18 2z",
  clipPath: "url(#peee9962114)",
  fill: "#8aff6d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M623 440l34-5h5l-33 4z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M507 482l28-2 2-10-27 2z",
  clipPath: "url(#peee9962114)",
  fill: "#beff39",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M550 601l4-9-6 8-5 10z",
  clipPath: "url(#peee9962114)",
  fill: "#00b4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M586 391l1 16 8 25-2-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ffa300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426 477l2 9 3-20-2-10z",
  clipPath: "url(#peee9962114)",
  fill: "#c7ff30",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M482 496l23-3 2-11-23 2z",
  clipPath: "url(#peee9962114)",
  fill: "#a7ff50",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M429 411l3 13 7-18-3-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ffa300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M612 525l26-7-1 9-26 8z",
  clipPath: "url(#peee9962114)",
  fill: "#63ff94",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M637 498l30-6 1 10-30 6z",
  clipPath: "url(#peee9962114)",
  fill: "#97ff60",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M427 445l2 11 5-19-2-13z",
  clipPath: "url(#peee9962114)",
  fill: "#ffea00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M659 465l32-5 3 8-31 6z",
  clipPath: "url(#peee9962114)",
  fill: "#d4ff23",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M553 617l-4-7-7 10 3 8z",
  clipPath: "url(#peee9962114)",
  fill: "#0090ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M549 610l1-9-7 9-1 10z",
  clipPath: "url(#peee9962114)",
  fill: "#00a0ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M629 439l33-4 5 1-32 4z",
  clipPath: "url(#peee9962114)",
  fill: "#ffde00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M430 511l4 3v-18l-3-4z",
  clipPath: "url(#peee9962114)",
  fill: "#8dff6a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M541 462l31-2 4-7-31 2z",
  clipPath: "url(#peee9962114)",
  fill: "#e4ff13",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M580 448l33-3 5-3-33 2z",
  clipPath: "url(#peee9962114)",
  fill: "#feed00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M449 514l14-2 1-14-14 1z",
  clipPath: "url(#peee9962114)",
  fill: "#8aff6d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M559 582l10-10-4 9-11 11z",
  clipPath: "url(#peee9962114)",
  fill: "#02e8f4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M572 611l-7-2-7 14 7 2z",
  clipPath: "url(#peee9962114)",
  fill: "#0098ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M590 543l21-8-2 10-21 8z",
  clipPath: "url(#peee9962114)",
  fill: "#46ffb1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M655 458l32-5 4 7-32 5z",
  clipPath: "url(#peee9962114)",
  fill: "#e4ff13",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475 295l3 16 15-2-3-16z",
  clipPath: "url(#peee9962114)",
  fill: "#920000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M450 328l4 17 12-10-3-17z",
  clipPath: "url(#peee9962114)",
  fill: "#df0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M635 440l32-4 6 2-33 4z",
  clipPath: "url(#peee9962114)",
  fill: "#ffde00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573 562l15-9-3 10-16 9z",
  clipPath: "url(#peee9962114)",
  fill: "#26ffd1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M602 498l-1 12v25l1-12z",
  clipPath: "url(#peee9962114)",
  fill: "#83ff73",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M651 451l32-4 4 6-32 5z",
  clipPath: "url(#peee9962114)",
  fill: "#f1fc06",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M640 442l33-4 5 4-32 4z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434 514l6 1v-17l-6-2zm6 1l9-1 1-15-10-1z",
  clipPath: "url(#peee9962114)",
  fill: "#8dff6a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M635 488l30-5 2 9-30 6z",
  clipPath: "url(#peee9962114)",
  fill: "#adff49",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M646 446l32-4 5 5-32 4z",
  clipPath: "url(#peee9962114)",
  fill: "#feed00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M510 472l27-1 4-9-28 1z",
  clipPath: "url(#peee9962114)",
  fill: "#d7ff1f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M612 514l26-6v10l-26 7z",
  clipPath: "url(#peee9962114)",
  fill: "#7dff7a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M464 498l18-2 2-12-19 1z",
  clipPath: "url(#peee9962114)",
  fill: "#aaff4d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M585 592l-7 2-6 17 6-1z",
  clipPath: "url(#peee9962114)",
  fill: "#00c4ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M585 444l33-2 5-2-32 2z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M484 484l23-2 3-10-24 1z",
  clipPath: "url(#peee9962114)",
  fill: "#c4ff33",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M555 591l4-9-5 10-4 9z",
  clipPath: "url(#peee9962114)",
  fill: "#00d8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M601 535l-4 9-2 22 3-8z",
  clipPath: "url(#peee9962114)",
  fill: "#46ffb1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M428 486l3 6 2-19-2-7z",
  clipPath: "url(#peee9962114)",
  fill: "#c1ff36",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M576 368l2 15 9 24-1-16z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M545 455l31-2 4-5-30 1z",
  clipPath: "url(#peee9962114)",
  fill: "#f8f500",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565 609l-6-4-6 12 5 6z",
  clipPath: "url(#peee9962114)",
  fill: "#00a8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M595 566l-6 6-4 20 5-5z",
  clipPath: "url(#peee9962114)",
  fill: "#0ff8e7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M633 478l30-4 2 9-30 5z",
  clipPath: "url(#peee9962114)",
  fill: "#c4ff33",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M592 532l20-7-1 10-21 8z",
  clipPath: "url(#peee9962114)",
  fill: "#63ff94",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M595 432v15l5 25-1-14z",
  clipPath: "url(#peee9962114)",
  fill: "#ffea00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M442 359l3 16 11-14-2-16z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M555 598v-7l-5 10-1 9z",
  clipPath: "url(#peee9962114)",
  fill: "#00c8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591 442l32-2 6-1-32 2z",
  clipPath: "url(#peee9962114)",
  fill: "#ffdb00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M559 605l-4-7-6 12 4 7z",
  clipPath: "url(#peee9962114)",
  fill: "#00b8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M563 570l10-8-4 10-10 10z",
  clipPath: "url(#peee9962114)",
  fill: "#1cffdb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M450 499l14-1 1-13-13-1z",
  clipPath: "url(#peee9962114)",
  fill: "#adff49",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M490 293l3 16 15 3-2-17z",
  clipPath: "url(#peee9962114)",
  fill: "#840000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M611 503l26-5 1 10-26 6z",
  clipPath: "url(#peee9962114)",
  fill: "#97ff60",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M575 550l15-7-2 10-15 9z",
  clipPath: "url(#peee9962114)",
  fill: "#43ffb4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M429 456l2 10 4-19-1-10z",
  clipPath: "url(#peee9962114)",
  fill: "#fbf100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M629 470l30-5 4 9-30 4z",
  clipPath: "url(#peee9962114)",
  fill: "#d7ff1f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M513 463l28-1 4-7h-27z",
  clipPath: "url(#peee9962114)",
  fill: "#eeff09",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M431 492l3 4 3-17-4-6z",
  clipPath: "url(#peee9962114)",
  fill: "#beff39",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M550 449l30-1 5-4-30 1z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M597 441l32-2 6 1-32 2z",
  clipPath: "url(#peee9962114)",
  fill: "gold",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M436 391l3 15 9-16-3-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6c00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M465 485l19-1 2-11h-18z",
  clipPath: "url(#peee9962114)",
  fill: "#caff2c",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M440 498l10 1 2-15-10-2z",
  clipPath: "url(#peee9962114)",
  fill: "#b4ff43",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M432 424l2 13 6-18-1-13z",
  clipPath: "url(#peee9962114)",
  fill: "#ffae00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486 473l24-1 3-9h-23z",
  clipPath: "url(#peee9962114)",
  fill: "#deff19",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565 346l1 16 12 21-2-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ff2d00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M625 462l30-4 4 7-30 5z",
  clipPath: "url(#peee9962114)",
  fill: "#ebff0c",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578 594l-7-1-6 16 7 2z",
  clipPath: "url(#peee9962114)",
  fill: "#0cf",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M463 318l3 17 14-6-2-17z",
  clipPath: "url(#peee9962114)",
  fill: "#b00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434 496l6 2 2-16-5-3z",
  clipPath: "url(#peee9962114)",
  fill: "#b7ff40",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M603 442l32-2 5 2-31 3z",
  clipPath: "url(#peee9962114)",
  fill: "gold",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M592 520l20-6v11l-20 7z",
  clipPath: "url(#peee9962114)",
  fill: "#7dff7a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M609 492l26-4 2 10-26 5z",
  clipPath: "url(#peee9962114)",
  fill: "#b1ff46",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M559 578l4-8-4 12-4 9z",
  clipPath: "url(#peee9962114)",
  fill: "#16ffe1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M620 455l31-4 4 7-30 4z",
  clipPath: "url(#peee9962114)",
  fill: "#f8f500",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M609 445l31-3 6 4-31 3z",
  clipPath: "url(#peee9962114)",
  fill: "#ffdb00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M506 295l2 17 16 6-2-16z",
  clipPath: "url(#peee9962114)",
  fill: "#890000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M615 449l31-3 5 5-31 4z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M600 472l-2 13 3 25 1-12z",
  clipPath: "url(#peee9962114)",
  fill: "#c1ff36",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M555 445l30-1 6-2-30 1z",
  clipPath: "url(#peee9962114)",
  fill: "gold",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M518 455h27l5-6h-27z",
  clipPath: "url(#peee9962114)",
  fill: "#ffea00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M577 538l15-6-2 11-15 7z",
  clipPath: "url(#peee9962114)",
  fill: "#60ff97",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M566 558l9-8-2 12-10 8z",
  clipPath: "url(#peee9962114)",
  fill: "#3cffba",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M551 328l2 16 13 18-1-16z",
  clipPath: "url(#peee9962114)",
  fill: "#e40000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M571 593l-7-3-5 15 6 4z",
  clipPath: "url(#peee9962114)",
  fill: "#00d8ff",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M589 572l-7 3-4 19 7-2z",
  clipPath: "url(#peee9962114)",
  fill: "#16ffe1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M560 585l-1-7-4 13v7z",
  clipPath: "url(#peee9962114)",
  fill: "#0cf4eb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M452 484l13 1 3-12-13-2z",
  clipPath: "url(#peee9962114)",
  fill: "#d1ff26",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M522 302l2 16 15 11-2-16z",
  clipPath: "url(#peee9962114)",
  fill: "#9b0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M431 466l2 7 4-17-2-9z",
  clipPath: "url(#peee9962114)",
  fill: "#f4f802",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M606 482l27-4 2 10-26 4z",
  clipPath: "url(#peee9962114)",
  fill: "#c7ff30",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M587 407l1 15 7 25v-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ffa700",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M537 313l2 16 14 15-2-16z",
  clipPath: "url(#peee9962114)",
  fill: "#b00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564 590l-4-5-5 13 4 7z",
  clipPath: "url(#peee9962114)",
  fill: "#02e8f4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M601 510l-4 10v24l4-9z",
  clipPath: "url(#peee9962114)",
  fill: "#80ff77",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M490 463h23l5-8-23-1z",
  clipPath: "url(#peee9962114)",
  fill: "#f8f500",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591 508l20-5 1 11-20 6z",
  clipPath: "url(#peee9962114)",
  fill: "#9aff5d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M597 544l-6 7-2 21 6-6z",
  clipPath: "url(#peee9962114)",
  fill: "#49ffad",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M561 443l30-1 6-1-29 1z",
  clipPath: "url(#peee9962114)",
  fill: "#ffd000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M468 473h18l4-10-17-1z",
  clipPath: "url(#peee9962114)",
  fill: "#e7ff0f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M454 345l2 16 13-9-3-17z",
  clipPath: "url(#peee9962114)",
  fill: "#f10800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M442 482l10 2 3-13-9-3z",
  clipPath: "url(#peee9962114)",
  fill: "#dbff1c",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M603 473l26-3 4 8-27 4z",
  clipPath: "url(#peee9962114)",
  fill: "#deff19",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M523 449h27l5-4h-26z",
  clipPath: "url(#peee9962114)",
  fill: "gold",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M433 473l4 6 3-16-3-7z",
  clipPath: "url(#peee9962114)",
  fill: "#ebff0c",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M478 312l2 17 15-2-2-18z",
  clipPath: "url(#peee9962114)",
  fill: "#9f0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M562 564l4-6-3 12-4 8z",
  clipPath: "url(#peee9962114)",
  fill: "#36ffc1",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434 437l1 10 7-16-2-12z",
  clipPath: "url(#peee9962114)",
  fill: "#ffb900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M568 442l29-1 6 1-29 1z",
  clipPath: "url(#peee9962114)",
  fill: "#fc0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M577 525l15-5v12l-15 6z",
  clipPath: "url(#peee9962114)",
  fill: "#80ff77",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M437 479l5 3 4-14-6-5z",
  clipPath: "url(#peee9962114)",
  fill: "#e1ff16",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M598 464l27-2 4 8-26 3z",
  clipPath: "url(#peee9962114)",
  fill: "#f1fc06",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M567 544l10-6-2 12-9 8z",
  clipPath: "url(#peee9962114)",
  fill: "#5dff9a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M445 375l3 15 10-13-2-16z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3b00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M582 575h-8l-3 18 7 1z",
  clipPath: "url(#peee9962114)",
  fill: "#1cffdb",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M588 496l21-4 2 11-20 5z",
  clipPath: "url(#peee9962114)",
  fill: "#b7ff40",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M574 443l29-1 6 3-29 1z",
  clipPath: "url(#peee9962114)",
  fill: "#fc0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M439 406l1 13 9-15-1-14z",
  clipPath: "url(#peee9962114)",
  fill: "#ff7a00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M593 456l27-1 5 7-27 2z",
  clipPath: "url(#peee9962114)",
  fill: "#ffea00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M495 454l23 1 5-6-22-1z",
  clipPath: "url(#peee9962114)",
  fill: "#ffdb00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M580 446l29-1 6 4-28 1z",
  clipPath: "url(#peee9962114)",
  fill: "#ffd000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M455 471l13 2 5-11-13-3z",
  clipPath: "url(#peee9962114)",
  fill: "#f4f802",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M587 450l28-1 5 6-27 1z",
  clipPath: "url(#peee9962114)",
  fill: "#ffdb00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M529 445h26l6-2-25-1z",
  clipPath: "url(#peee9962114)",
  fill: "#ffc800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578 383l1 16 9 23-1-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6c00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M595 447l-1 13 4 25 2-13z",
  clipPath: "url(#peee9962114)",
  fill: "#fbf100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M563 570l-1-6-3 14 1 7z",
  clipPath: "url(#peee9962114)",
  fill: "#30ffc7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473 462l17 1 5-9-17-2z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M574 575l-6-1-4 16 7 3z",
  clipPath: "url(#peee9962114)",
  fill: "#23ffd4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M568 574l-5-4-3 15 4 5z",
  clipPath: "url(#peee9962114)",
  fill: "#29ffce",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M585 485l21-3 3 10-21 4z",
  clipPath: "url(#peee9962114)",
  fill: "#d1ff26",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M575 512l16-4 1 12-15 5z",
  clipPath: "url(#peee9962114)",
  fill: "#9dff5a",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M435 447l2 9 6-16-1-9z",
  clipPath: "url(#peee9962114)",
  fill: "#ffc400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591 551l-7 4-2 20 7-3z",
  clipPath: "url(#peee9962114)",
  fill: "#4dffaa",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M493 309l2 18 16 2-3-17z",
  clipPath: "url(#peee9962114)",
  fill: "#920000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M536 442l25 1 7-1-26-1z",
  clipPath: "url(#peee9962114)",
  fill: "#ffc100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M446 468l9 3 5-12-9-5z",
  clipPath: "url(#peee9962114)",
  fill: "#feed00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564 549l3-5-1 14-4 6z",
  clipPath: "url(#peee9962114)",
  fill: "#5aff9d",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M466 335l3 17 14-6-3-17z",
  clipPath: "url(#peee9962114)",
  fill: "#c80000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M598 485l-3 11 2 24 4-10z",
  clipPath: "url(#peee9962114)",
  fill: "#beff39",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M567 530l10-5v13l-10 6z",
  clipPath: "url(#peee9962114)",
  fill: "#80ff77",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M501 448l22 1 6-4-21-2z",
  clipPath: "url(#peee9962114)",
  fill: "#ffc800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M597 520l-6 8v23l6-7z",
  clipPath: "url(#peee9962114)",
  fill: "#80ff77",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M581 475l22-2 3 9-21 3z",
  clipPath: "url(#peee9962114)",
  fill: "#e7ff0f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M437 456l3 7 6-15-3-8z",
  clipPath: "url(#peee9962114)",
  fill: "#ffd300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M566 362l1 16 12 21-1-16z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M440 463l6 5 5-14-5-6z",
  clipPath: "url(#peee9962114)",
  fill: "#ffde00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M543 441l25 1 6 1-24-1z",
  clipPath: "url(#peee9962114)",
  fill: "#ffb900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460 459l13 3 5-10-12-4z",
  clipPath: "url(#peee9962114)",
  fill: "gold",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M478 452l17 2 6-6-17-3z",
  clipPath: "url(#peee9962114)",
  fill: "#fc0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M440 419l2 12 8-15-1-12z",
  clipPath: "url(#peee9962114)",
  fill: "#ff8600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573 499l15-3 3 12-16 4z",
  clipPath: "url(#peee9962114)",
  fill: "#baff3c",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M508 312l3 17 15 6-2-17z",
  clipPath: "url(#peee9962114)",
  fill: "#960000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M576 465l22-1 5 9-22 2z",
  clipPath: "url(#peee9962114)",
  fill: "#fbf100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565 553l-1-4-2 15 1 6z",
  clipPath: "url(#peee9962114)",
  fill: "#56ffa0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M584 555l-8 1-2 19h8z",
  clipPath: "url(#peee9962114)",
  fill: "#4dffaa",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M456 361l2 16 12-9-1-16z",
  clipPath: "url(#peee9962114)",
  fill: "#ff1300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M550 442l24 1 6 3-23-1z",
  clipPath: "url(#peee9962114)",
  fill: "#ffbd00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M588 422l-1 14 7 24 1-13z",
  clipPath: "url(#peee9962114)",
  fill: "#ffae00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M553 344l2 17 12 17-1-16z",
  clipPath: "url(#peee9962114)",
  fill: "#f10800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M508 443l21 2 7-3-21-2z",
  clipPath: "url(#peee9962114)",
  fill: "#ffb900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M570 457l23-1 5 8-22 1z",
  clipPath: "url(#peee9962114)",
  fill: "#ffdb00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M448 390l1 14 10-12-1-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ff4a00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M557 445l23 1 7 4h-24z",
  clipPath: "url(#peee9962114)",
  fill: "#ffc100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M563 450h24l6 6-23 1z",
  clipPath: "url(#peee9962114)",
  fill: "#fc0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524 318l2 17 15 11-2-17z",
  clipPath: "url(#peee9962114)",
  fill: "#a40000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M566 516l9-4 2 13-10 5z",
  clipPath: "url(#peee9962114)",
  fill: "#a0ff56",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539 329l2 17 14 15-2-17z",
  clipPath: "url(#peee9962114)",
  fill: "#c40000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M569 556l-4-3-2 17 5 4z",
  clipPath: "url(#peee9962114)",
  fill: "#53ffa4",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564 534l3-4v14l-3 5z",
  clipPath: "url(#peee9962114)",
  fill: "#80ff77",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M576 556h-7l-1 18 6 1z",
  clipPath: "url(#peee9962114)",
  fill: "#50ffa7",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M569 487l16-2 3 11-15 3z",
  clipPath: "url(#peee9962114)",
  fill: "#d7ff1f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M451 454l9 5 6-11-9-5z",
  clipPath: "url(#peee9962114)",
  fill: "#ffc800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M480 329l3 17 14-2-2-17z",
  clipPath: "url(#peee9962114)",
  fill: "#ad0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M442 431l1 9 8-13-1-11z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M484 445l17 3 7-5-16-4z",
  clipPath: "url(#peee9962114)",
  fill: "#ffb600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591 528l-7 6v21l7-4z",
  clipPath: "url(#peee9962114)",
  fill: "#80ff77",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M515 440l21 2 7-1-21-2z",
  clipPath: "url(#peee9962114)",
  fill: "#ffae00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M466 448l12 4 6-7-11-5z",
  clipPath: "url(#peee9962114)",
  fill: "#ffb900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M594 460l-4 12 5 24 3-11z",
  clipPath: "url(#peee9962114)",
  fill: "#f8f500",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M446 448l5 6 6-11-4-7z",
  clipPath: "url(#peee9962114)",
  fill: "#ffb600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M443 440l3 8 7-12-2-9z",
  clipPath: "url(#peee9962114)",
  fill: "#ffa700",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M595 496l-6 9 2 23 6-8z",
  clipPath: "url(#peee9962114)",
  fill: "#baff3c",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564 475h17l4 10-16 2z",
  clipPath: "url(#peee9962114)",
  fill: "#f1fc06",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M563 502l10-3 2 13-9 4z",
  clipPath: "url(#peee9962114)",
  fill: "#c1ff36",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565 537l-1-3v15l1 4z",
  clipPath: "url(#peee9962114)",
  fill: "#80ff77",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M579 399l-1 15 9 22 1-14z",
  clipPath: "url(#peee9962114)",
  fill: "#ff7300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M522 439l20 2 8 1-20-2z",
  clipPath: "url(#peee9962114)",
  fill: "#ffa700",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M449 404l1 12 9-11v-13z",
  clipPath: "url(#peee9962114)",
  fill: "#ff5d00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M562 518l4-2 1 14-3 4z",
  clipPath: "url(#peee9962114)",
  fill: "#a4ff53",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M469 352l1 16 13-6v-16z",
  clipPath: "url(#peee9962114)",
  fill: "#da0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M559 465h17l5 10h-17z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M492 439l16 4 7-3-16-4z",
  clipPath: "url(#peee9962114)",
  fill: "#ffa300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M584 534l-8 3v19l8-1z",
  clipPath: "url(#peee9962114)",
  fill: "#80ff77",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M495 327l2 17 15 2-1-17z",
  clipPath: "url(#peee9962114)",
  fill: "#a40000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M530 440l20 2 7 3-19-2z",
  clipPath: "url(#peee9962114)",
  fill: "#ffab00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M457 443l9 5 7-8-8-6z",
  clipPath: "url(#peee9962114)",
  fill: "#ffa700",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M569 538l-4-1v16l4 3z",
  clipPath: "url(#peee9962114)",
  fill: "#80ff77",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M458 377l1 15 11-9v-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ff2500",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552 456l18 1 6 8h-17z",
  clipPath: "url(#peee9962114)",
  fill: "#fc0",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M538 443l19 2 6 5-18-1z",
  clipPath: "url(#peee9962114)",
  fill: "#ffae00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M576 537l-7 1v18h7z",
  clipPath: "url(#peee9962114)",
  fill: "#80ff77",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473 440l11 5 8-6-12-5z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9f00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M545 449l18 1 7 7-18-1z",
  clipPath: "url(#peee9962114)",
  fill: "#ffbd00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M559 488l10-1 4 12-10 3z",
  clipPath: "url(#peee9962114)",
  fill: "#e1ff16",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M567 378v16l11 20 1-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3f00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M450 416l1 11 9-11-1-11z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6f00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M587 436l-3 13 6 23 4-12z",
  clipPath: "url(#peee9962114)",
  fill: "#ffb600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499 436l16 4 7-1-14-4z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M453 436l4 7 8-9-4-8z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M589 505l-7 7 2 22 7-6z",
  clipPath: "url(#peee9962114)",
  fill: "#b7ff40",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M511 329l1 17 15 6-1-17z",
  clipPath: "url(#peee9962114)",
  fill: "#a40000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M563 519l-1-1 2 16 1 3z",
  clipPath: "url(#peee9962114)",
  fill: "#a7ff50",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M559 503l4-1 3 14-4 2z",
  clipPath: "url(#peee9962114)",
  fill: "#c7ff30",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M451 427l2 9 8-10-1-10z",
  clipPath: "url(#peee9962114)",
  fill: "#ff8200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M590 472l-5 11 4 22 6-9z",
  clipPath: "url(#peee9962114)",
  fill: "#f1fc06",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M554 475h10l5 12-10 1z",
  clipPath: "url(#peee9962114)",
  fill: "#fbf100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M555 361v16l12 17v-16z",
  clipPath: "url(#peee9962114)",
  fill: "#ff1300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M483 346v16l14-2v-16z",
  clipPath: "url(#peee9962114)",
  fill: "#c40000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 335l1 17 14 11v-17z",
  clipPath: "url(#peee9962114)",
  fill: "#b60000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M508 435l14 4 8 1-14-4z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M480 434l12 5 7-3-10-5zm-15 0l8 6 7-6-6-7z",
  clipPath: "url(#peee9962114)",
  fill: "#ff8d00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M541 346v17l14 14v-16z",
  clipPath: "url(#peee9962114)",
  fill: "#d10000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M459 392v13l11-8v-14z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M568 519h-5l2 18 4 1z",
  clipPath: "url(#peee9962114)",
  fill: "#adff49",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M582 512l-8 4 2 21 8-3z",
  clipPath: "url(#peee9962114)",
  fill: "#b4ff43",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M548 464l11 1 5 10h-10z",
  clipPath: "url(#peee9962114)",
  fill: "#ffd300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M470 368v15l13-5v-16z",
  clipPath: "url(#peee9962114)",
  fill: "#f10800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M516 436l14 4 8 3-13-3z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M574 516l-6 3 1 19 7-1z",
  clipPath: "url(#peee9962114)",
  fill: "#b1ff46",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M555 488h4l4 14-4 1z",
  clipPath: "url(#peee9962114)",
  fill: "#ebff0c",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578 414l-3 14 9 21 3-13z",
  clipPath: "url(#peee9962114)",
  fill: "#ff7e00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M541 454l11 2 7 9-11-1z",
  clipPath: "url(#peee9962114)",
  fill: "#ffb900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M525 440l13 3 7 6-12-3z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9c00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M560 502l-1 1 3 15 1 1z",
  clipPath: "url(#peee9962114)",
  fill: "#ceff29",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M533 446l12 3 7 7-11-2z",
  clipPath: "url(#peee9962114)",
  fill: "#ffa700",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M461 426l4 8 9-7-4-8z",
  clipPath: "url(#peee9962114)",
  fill: "#f70",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M489 431l10 5 9-1-10-6z",
  clipPath: "url(#peee9962114)",
  fill: "#ff8200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M459 405l1 11 10-7v-12z",
  clipPath: "url(#peee9962114)",
  fill: "#ff4a00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M497 344v16l14 3 1-17z",
  clipPath: "url(#peee9962114)",
  fill: "#b60000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M585 483l-7 8 4 21 7-7z",
  clipPath: "url(#peee9962114)",
  fill: "#ebff0c",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460 416l1 10 9-7v-10z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M474 427l6 7 9-3-6-8z",
  clipPath: "url(#peee9962114)",
  fill: "#f70",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M584 449l-6 12 7 22 5-11z",
  clipPath: "url(#peee9962114)",
  fill: "#ffc100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M549 474l5 1 5 13h-4z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564 500l-4 2 3 17h5z",
  clipPath: "url(#peee9962114)",
  fill: "#d7ff1f",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M567 394l-3 15 11 19 3-14z",
  clipPath: "url(#peee9962114)",
  fill: "#ff4a00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M498 429l10 6 8 1-9-5z",
  clipPath: "url(#peee9962114)",
  fill: "#ff7a00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M470 383v14l12-5 1-14z",
  clipPath: "url(#peee9962114)",
  fill: "#ff1a00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M483 362v16l13-2 1-16z",
  clipPath: "url(#peee9962114)",
  fill: "#da0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M555 486v2l4 15 1-1z",
  clipPath: "url(#peee9962114)",
  fill: "#f4f802",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578 491l-8 6 4 19 8-4z",
  clipPath: "url(#peee9962114)",
  fill: "#e4ff13",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512 346l-1 17 15 6 1-17z",
  clipPath: "url(#peee9962114)",
  fill: "#b00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M542 461l6 3 6 11-5-1z",
  clipPath: "url(#peee9962114)",
  fill: "#ffc100",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M570 497l-6 3 4 19 6-3z",
  clipPath: "url(#peee9962114)",
  fill: "#deff19",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M470 419l4 8 9-4-2-8z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M507 431l9 5 9 4-8-5z",
  clipPath: "url(#peee9962114)",
  fill: "#ff7e00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M483 423l6 8 9-2-5-7z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6c00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M555 377l-2 15 11 17 3-15z",
  clipPath: "url(#peee9962114)",
  fill: "#ff1e00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M534 450l7 4 7 10-6-3z",
  clipPath: "url(#peee9962114)",
  fill: "#ffa700",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M527 352l-1 17 14 10 1-16z",
  clipPath: "url(#peee9962114)",
  fill: "#c80000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M517 435l8 5 8 6-7-4z",
  clipPath: "url(#peee9962114)",
  fill: "#ff8600",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M470 397v12l11-5 1-12z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M575 428l-5 12 8 21 6-12z",
  clipPath: "url(#peee9962114)",
  fill: "#ff8900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 442l7 4 8 8-7-4z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M541 363l-1 16 13 13 2-15z",
  clipPath: "url(#peee9962114)",
  fill: "#e40000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578 461l-6 9 6 21 7-8z",
  clipPath: "url(#peee9962114)",
  fill: "#ffc800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M470 409v10l11-4v-11z",
  clipPath: "url(#peee9962114)",
  fill: "#ff4a00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M549 471v3l6 14v-2z",
  clipPath: "url(#peee9962114)",
  fill: "#ffd300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M559 483l-4 3 5 16 4-2z",
  clipPath: "url(#peee9962114)",
  fill: "#feed00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M497 360l-1 16 14 2 1-15z",
  clipPath: "url(#peee9962114)",
  fill: "#cd0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M493 422l5 7 9 2-4-7z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M483 378l-1 14 12-2 2-14z",
  clipPath: "url(#peee9962114)",
  fill: "#f10800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M572 470l-7 7 5 20 8-6z",
  clipPath: "url(#peee9962114)",
  fill: "#ffd300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M481 415l2 8 10-1-2-9z",
  clipPath: "url(#peee9962114)",
  fill: "#ff5200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565 477l-6 6 5 17 6-3z",
  clipPath: "url(#peee9962114)",
  fill: "#ffe200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M541 457l1 4 7 13v-3z",
  clipPath: "url(#peee9962114)",
  fill: "#ffb200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564 409l-4 13 10 18 5-12z",
  clipPath: "url(#peee9962114)",
  fill: "#ff5900",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M503 424l4 7 10 4-4-7z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M482 392l-1 12 11-1 2-13z",
  clipPath: "url(#peee9962114)",
  fill: "#f20",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552 466l-3 5 6 15 4-3z",
  clipPath: "url(#peee9962114)",
  fill: "#ffc400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M481 404v11l10-2 1-10z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M570 440l-6 11 8 19 6-9z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M511 363l-1 15 13 6 3-15z",
  clipPath: "url(#peee9962114)",
  fill: "#d10000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M533 445l1 5 8 11-1-4z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M513 428l4 7 9 7-3-6z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6c00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M523 436l3 6 8 8-1-5z",
  clipPath: "url(#peee9962114)",
  fill: "#ff7e00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M553 392l-4 14 11 16 4-13z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M491 413l2 9 10 2v-9z",
  clipPath: "url(#peee9962114)",
  fill: "#ff4a00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M496 376l-2 14 13 2 3-14z",
  clipPath: "url(#peee9962114)",
  fill: "#e80000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 369l-3 15 13 9 4-14z",
  clipPath: "url(#peee9962114)",
  fill: "#df0000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M558 459l-6 7 7 17 6-6z",
  clipPath: "url(#peee9962114)",
  fill: "#ffb200",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M540 379l-4 14 13 13 4-14z",
  clipPath: "url(#peee9962114)",
  fill: "#fa0f00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564 451l-6 8 7 18 7-7z",
  clipPath: "url(#peee9962114)",
  fill: "#ffa300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M544 451l-3 6 8 14 3-5z",
  clipPath: "url(#peee9962114)",
  fill: "#ff9f00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M560 422l-5 12 9 17 6-11z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M492 403l-1 10 12 2 1-10z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3000",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M503 415v9l10 4 1-8z",
  clipPath: "url(#peee9962114)",
  fill: "#ff4a00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M494 390l-2 13 12 2 3-13z",
  clipPath: "url(#peee9962114)",
  fill: "#ff1a00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M535 438l-2 7 8 12 3-6z",
  clipPath: "url(#peee9962114)",
  fill: "#ff7e00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M510 378l-3 14 13 6 3-14z",
  clipPath: "url(#peee9962114)",
  fill: "#ed0400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M514 420l-1 8 10 8 1-8z",
  clipPath: "url(#peee9962114)",
  fill: "#f50",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M549 443l-5 8 8 15 6-7z",
  clipPath: "url(#peee9962114)",
  fill: "#ff8d00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524 428l-1 8 10 9 2-7z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M555 434l-6 9 9 16 6-8z",
  clipPath: "url(#peee9962114)",
  fill: "#ff7a00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M549 406l-5 13 11 15 5-12z",
  clipPath: "url(#peee9962114)",
  fill: "#ff4300",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M504 405l-1 10 11 5 2-10z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3400",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M523 384l-3 14 12 9 4-14z",
  clipPath: "url(#peee9962114)",
  fill: "#fa0f00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M507 392l-3 13 12 5 4-12z",
  clipPath: "url(#peee9962114)",
  fill: "#ff1a00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M536 393l-4 14 12 12 5-13z",
  clipPath: "url(#peee9962114)",
  fill: "#f20",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539 429l-4 9 9 13 5-8z",
  clipPath: "url(#peee9962114)",
  fill: "#ff6800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M544 419l-5 10 10 14 6-9z",
  clipPath: "url(#peee9962114)",
  fill: "#f50",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M516 410l-2 10 10 8 4-10z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3b00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M528 418l-4 10 11 10 4-9z",
  clipPath: "url(#peee9962114)",
  fill: "#ff4e00",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M520 398l-4 12 12 8 4-11z",
  clipPath: "url(#peee9962114)",
  fill: "#ff2500",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M532 407l-4 11 11 11 5-10z",
  clipPath: "url(#peee9962114)",
  fill: "#ff3800",
  transform: "translate(-407 -239)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#musd",
  x: 220,
  y: 220,
  width: 200,
  height: 200
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "peee9962114",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M140 108h865v696H140z"
})));

function SvgMusd3Crv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 460 460",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusd3Crv);
export default __webpack_public_path__ + "static/media/musd3CRV.fe7cf732.svg";
export { ForwardRef as ReactComponent };